import { getRepaymentStatus } from "../utils/repaymentStatus";
import { getPersonData } from "../utils/myinfoData";
import React from "react";
import { useState, useEffect } from "react";
import Cookies from "js-cookie";
import Modal from "antd/es/modal/Modal";
import { Collapse, message } from "antd";
import TableRepaymentUserDatabase from "../components/TableRepaymentUserDatabase";
import * as XLSX from "xlsx";
import * as Icons from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { isEqual } from "lodash";
import { useHistory } from "react-router-dom";
import LocalPoliceIcon from "@mui/icons-material/LocalPolice";
import PersonIcon from "@mui/icons-material/Person";
import BusinessIcon from "@mui/icons-material/Business";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  PDFDownloadLink,
  Font,
  PDFViewer,
} from "@react-pdf/renderer";
import {
  Form,
  Input,
  Select,
  Button,
  Col,
  Row,
  Avatar,
  Upload,
  Card,
  Tabs,
  notification,
  DatePicker,
  Space,
  InputNumber,
  Tooltip,
  Tag,
} from "antd";
import logo from "../assets/img/SL-01.png";
import boldFont from "../assets/font/Poppins-SemiBold.ttf";
import { NumbersOutlined } from "@mui/icons-material";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import pdfToText from "react-pdftotext";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { CircularProgress } from "@mui/material";
import ProfileViewer from "../pages/borrower-dashboard/ProfileViewer";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

Font.register({
  family: "Poppins",
  fonts: [
    { src: boldFont, fontWeight: 700 }, // Bold (700)
  ],
});

const UserDatabase = ({ searchTerm }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [paramValue, setParamValue] = useState(""); // Extract the "param" value

  useEffect(() => {
    if (searchParams.get("search")) {
      setParamValue(searchParams.get("search"));
    } else {
      setParamValue("");
    }
    setActivePageb(1);
    setActivePagel(1);
  }, [searchParams.get("search")]);
  const history = useHistory();
  const [screenWidth, setScreenWidth] = useState(1920);
  const iconLibrary = Icons;
  const [isLoadingScreen, setIsLoadingScreen] = useState(false);
  const iconNames = Object.keys(iconLibrary);
  const [dataAll, setDataAll] = useState([]);
  const [dataAll2, setDataAll2] = useState([]);

  const [dataLender, setDataLender] = useState([]);
  const [dataBorrower, setDataBorrower] = useState([]);
  const [subscribedEmail, setDataSubscribedEmail] = useState([]);

  const [activeTab, setActiveTab] = useState("Borrower");
  const [activeTab2, setActiveTab2] = useState("Admin");
  const [activeUser, setActiveUser] = useState(null);
  const [activeUser2, setActiveUser2] = useState(null);
  const [welcomeWizardResponse, setWelcomeWizardResponse] = useState(null);
  const [isWelcomeWizardLoading, setIsWelcomeWizardLoading] = useState(false);
  const [welcomeWizardError, setWelcomeWizardError] = useState(null);
  const [hasLoadedWelcomeWizard, setHasLoadedWelcomeWizard] = useState(false);
  const [modal1, setModal1] = useState(false);
  const [modal4, setModal4] = useState(false);
  const [modal5, setModal5] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [modal3, setModal3] = useState(false);
  const [selectedLoan, setSelectedLoan] = useState(null);
  const [selectedLoan2, setSelectedLoan2] = useState(null);
  const { Panel } = Collapse;
  const [dataRepaymentSchedule, setDataRepaymentSchedule] = useState([]);
  const lenderProductOptions = [
    { label: "Personal", value: "personal" },
    { label: "Corporate", value: "corporate" },
    { label: "Property", value: "property" },
  ];
  const lenderProductColors = {
    personal: "magenta",
    corporate: "purple",
    property: "green",
  };

  const [dataSingpassModal, setDataSingpassModal] = useState(false);
  const [needOtherAuthoriser, setNeedOtherAuthoriser] = useState(false);
  const [otherAuthoriserDetails, setOtherAuthoriserDetails] = useState(null);
  const [openDataIndex, setOpenDataIndex] = useState(null);
  const [keyman, setKeyman] = useState("");
  const [viewingUser, setViewingUser] = useState(0);
  const [viewingTab, setViewingTab] = useState(0);
  const [liveUserData, setLiveUserData] = useState(null);
  const [singpassData, setSingpassData] = useState(null);
  const [myinfoData, setMyinfoData] = useState(null);
  const [combinedSingpassData, setCombinedSingpassData] = useState([]);
  const [allCBSData, setAllCBSData] = useState([]);
  const [badgeVerified, setBadgeVerified] = useState(false);
  const [updatingUser, setUpdatingUser] = useState(null);
  const [keymanDetails, setKeymanDetails] = useState({
    contact: "",
    email: "",
  });
  const [accountManagerModalIsOpen, setAccountManagerModalIsOpen] =
    useState(false);
  const [accountManagerDetails, setAccountManagerDetails] = useState({
    profile: "",
    name: "",
    ph: "",
    email: "",
  });
  const [backupContact, setBackupContact] = useState("");

  const [employeeList, setEmployeeList] = useState([]);
  const [creditReportFile, setCreditReportFile] = useState([]);
  const [creditFile, setCreditFile] = useState(null);
  const [CBSImpLoan, setCBSImpLoan] = useState(null);
  const [defaults, setDefaults] = useState(null);
  const [bankcruptcyProceedings, setBankcruptcyProceedings] = useState(null);
  const [overdueBalance, setOverdueBalance] = useState(null);
  const [monthlyCommitment, setMonthlyCommitment] = useState(null);
  const [chartData, setChartData] = useState(null);
  const [enquiryDate, setEnquiryDate] = useState(null);
  const [chartMaxValue, setChartMaxValue] = useState(null);

  useEffect(() => {
    setWelcomeWizardResponse(null);
    setWelcomeWizardError(null);
    setIsWelcomeWizardLoading(false);
    setHasLoadedWelcomeWizard(false);
  }, [activeTab, activeUser]);
  const [
    cBSImpLoanSupplementaryMonthlyInstallment,
    setCBSImpLoanSupplementaryMonthlyInstallment,
  ] = useState(null);

  const [isConciergeModalOpen, setIsConciergeModalOpen] = useState(false);
  const [conciergeCreatingLoanData, setConciergeCreatingLoanData] = useState({
    loan_id: "",
    lender_id: "",
    borrower_id: "",
    lender_sign: 1,
    borrower_uploaded_agreement: 1,
    borrower_sign: 1,
    type: "simple",
    express: 0,
    status: "ongoing",
    principal: 0,
    amount: 0,
    admin_fee: 0,
    total_admin_fee: 0,
    input_interest_rate: 0,
    interest_rate: 0,
    period: 0,
    monthly_installment: 0,
    revenue: 0,
    receipt: "done",
    authorization_required: 0,
    fees_collected: 0,
    processing_fee: 0,
    input_processing_fee: 0,
    created_at: "",
  });

  function extractText(file) {
    pdfToText(file)
      .then((text) => {
        console.log(text);
        setCreditFile(text);
      })
      .catch((error) => {
        console.error("Failed to extract text from pdf");
      });
  }

  function splitStringToRows(inputString) {
    // Use a regular expression to match exactly two spaces
    const rows = inputString.split(/(?<! ) {2}(?! )/);

    return rows;
  }

  const normalizeAllowedProducts = (value) => {
    if (!value) {
      return [];
    }

    if (Array.isArray(value)) {
      return value;
    }

    if (typeof value === "string") {
      try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        return [];
      }
    }

    return [];
  };

  const buildPaginationItems = (currentPage, totalPages, windowSize = 10) => {
    if (!totalPages || totalPages <= 0) {
      return [];
    }

    if (totalPages <= windowSize + 2) {
      return Array.from({ length: totalPages }, (_, index) => index + 1);
    }

    const halfWindow = Math.floor(windowSize / 2);
    let startPage = Math.max(2, currentPage - halfWindow);
    let endPage = startPage + windowSize - 1;

    if (endPage >= totalPages) {
      endPage = totalPages - 1;
      startPage = Math.max(2, endPage - windowSize + 1);
    }

    const items = [1];

    if (startPage > 2) {
      items.push("left-ellipsis");
    }

    for (let page = startPage; page <= endPage; page += 1) {
      items.push(page);
    }

    if (endPage < totalPages - 1) {
      items.push("right-ellipsis");
    }

    items.push(totalPages);

    return items;
  };

  const parseMaybeJson = (value) => {
    if (!value) return null;
    if (typeof value === "object") return value;
    if (typeof value !== "string") return null;

    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  };

  const hasSingpassPayload = (user) => Boolean(parseMaybeJson(user?.singpass_data));
  const hasMyInfoPayload = (user) => Boolean(parseMaybeJson(user?.myinfo_data));

  const getBorrowerDisplayName = (user) => {
    const singpassPayload = parseMaybeJson(user?.singpass_data);
    const myinfoPayload = parseMaybeJson(user?.myinfo_data);

    return (
      singpassPayload?.entity?.["basic-profile"]?.["entity-name"]?.value ||
      user?.entity_name ||
      myinfoPayload?.name?.value ||
      getPersonData(myinfoPayload)?.name?.value ||
      user?.principal_name ||
      "Borrower"
    );
  };

  function extractTextBetween(beforeText, afterText) {
    if (creditFile !== null) {
      // Replace multiple spaces in beforeText and afterText with \s+ to match any number of spaces
      const beforeTextPattern = beforeText.replace(/\s+/g, "\\s+");
      const afterTextPattern = afterText.replace(/\s+/g, "\\s+");

      // Create a regex to find text between the beforeTextPattern and afterTextPattern
      const regex = new RegExp(`${beforeTextPattern}(.*?)${afterTextPattern}`);

      const match = creditFile.match(regex);
      if (match && match[1]) {
        return match[1].trim(); // Extract and trim any leading/trailing spaces
      } else {
        return "Text not found between specified markers";
      }
    }
  }

  function removeCharactersAroundPage(inputString) {
    // Regular expression to find the word "page" and capture the preceding and following characters
    const regex = /(.{0,19})page(.{0,7})/g; // Adjusted to capture more characters before "page"

    // Replace the matched segments with the word "page" alone
    const result = inputString.replace(regex, (match, p1, p2) => {
      // Determine the number of characters to remove from the beginning and the end
      const charsToRemoveBefore = 19 - 11; // 4 characters before the original 11
      const charsToRemoveAfter = 11 - 4;

      const removedStart =
        p1.length > charsToRemoveBefore
          ? p1.slice(0, -charsToRemoveBefore)
          : "";
      const removedEnd =
        p2.length > charsToRemoveAfter ? p2.slice(charsToRemoveAfter) : "";
      return `${removedStart}page${removedEnd}`;
    });

    return result;
  }

  function extractTextBetweeforloandetails(creditText, beforeText, afterText) {
    // Find the starting index of beforeText in the original text
    if (creditText !== null) {
      const startIndex = creditText.indexOf(beforeText);
      if (startIndex === -1) {
        return "Before text not found";
      }

      // Adjust the starting index to exclude the beforeText
      const adjustedStartIndex = startIndex + beforeText.length;

      // Find the ending index of afterText in the original text
      const endIndex = creditText.indexOf(afterText, adjustedStartIndex);
      if (endIndex === -1) {
        return "After text not found";
      }

      // Extract the text between beforeText and afterText
      const extractedText = creditText.substring(adjustedStartIndex, endIndex);

      return extractedText;
    }
  }

  const uploadCBSReport = async (file) => {
    try {
      const formData1 = new FormData();
      formData1.append("credit_report", creditReportFile);

      const targetLine =
        "  account status history product type   grantor bank   account type date opened / date closed   overdue balance last 12 cycles / cash advance / balance transfer full payment  ";

      function getMaxValue(data) {
        return data.reduce((max, current) => {
          // Parse the current value to a float for accurate comparison
          const currentValue = parseFloat(current.value.replace(/,/g, ""));
          return currentValue > max ? currentValue : max;
        }, 0);
      }
      function parseData(inputString) {
        // Adjusted regex to account for extra numbers before the relevant value
        const regex =
          /([a-zA-Z]+\s\d{4})\s+All\s+All\s+[\d,.]+\s+([\d,.]+\.\d{2})/g;

        const result = [];
        let match;

        // Loop through the matches and create the array of objects
        while ((match = regex.exec(inputString)) !== null) {
          const date = match[1];
          const value = match[2];
          result.push({ date, value });
        }

        return result;
      }

      function formatAndMergeString(input) {
        // Define patterns to split by
        const patterns = [
          "unsecured overdraft",
          "unsecured credit card",
          "other",
          "motor vehicle loan",
          "hdb loan",
          "private residential purchase",
          "unsecured personal loan",
        ];

        // Create a regular expression to split the string at the start of each record
        const regex = new RegExp(`(${patterns.join("|")})`, "g");

        // Split and rejoin the string with line breaks
        const formattedString = input
          .split(regex) // Split using the pattern
          .filter(Boolean) // Remove empty strings
          .map((str) => str.trim()) // Trim unnecessary spaces
          .join("\n"); // Rejoin with line breaks

        // Now, split each line by three or more spaces to create arrays
        const lines = formattedString.split("\n");

        // Merge consecutive elements, but check if the next element exists
        const result = [];
        for (let i = 0; i < lines.length; i += 2) {
          // Check if the next element exists before attempting to split
          if (lines[i + 1]) {
            const record = [lines[i]].concat(
              lines[i + 1].split(/\s{3,}/).map((part) => part.trim())
            );
            result.push(record);
          } else {
            // If there is no next element, just push the current one as is
            result.push([lines[i]]);
          }
        }

        return result;
      }
      function hasOverdueBalance(data) {
        // Iterate over the data (array of arrays)
        return data.some((item) => {
          // Check if the fifth index exists and is a valid number (i.e., a string that can be converted to a number)
          const fifthIndex = item[4];
          return !isNaN(fifthIndex) && parseFloat(fifthIndex) > 0; // If it's a number and greater than 0, consider it as overdue balance
        });
      }

      const combinePrivateResidentialPurchase = (splitArray) => {
        const combinedArray = [];

        for (let i = 0; i < splitArray.length; i++) {
          if (splitArray[i].includes("private residential purchase")) {
            combinedArray.push(
              splitArray[i] + "  " + (splitArray[i + 1] || "")
            );
            i++; // Skip the next element as it has been combined
          } else {
            combinedArray.push(splitArray[i]);
          }
        }

        return combinedArray;
      };
      const splitExactlyTwoSpaces = (inputString) => {
        // Split the string using the regular expression for exactly two spaces
        const splitArray = inputString.split(/(?<! )  (?! )/);
        return splitArray;
      };
      const combineSingleOrJoint = (splitArray) => {
        const combinedArray = [];

        for (let i = 0; i < splitArray.length; i++) {
          if (
            splitArray[i].startsWith("single") ||
            splitArray[i].startsWith("joint")
          ) {
            if (combinedArray.length > 0) {
              combinedArray[combinedArray.length - 1] += "  " + splitArray[i];
            } else {
              combinedArray.push(splitArray[i]);
            }
          } else {
            combinedArray.push(splitArray[i]);
          }
        }

        return combinedArray;
      };

      console.log(file);
      console.log(extractText(file));

      const textWithoutPage = removeCharactersAroundPage(
        creditFile.toLowerCase()
      ).replace(/page/g, "");

      const extract = extractTextBetweeforloandetails(
        textWithoutPage,
        "aggregated outstanding balances  month   product type   grantor bank   secured balances  unsecured balances interest bearing  unsecured balances non-interest bearing  exempted unsecured balances  ",
        "total"
      );

      const extract2ForMonthlyCommitment = extractTextBetweeforloandetails(
        textWithoutPage,
        "aggregated monthly instalment",
        "aggregated monthly instalments for preceding 5 months"
      );

      console.log(extract2ForMonthlyCommitment);

      const extract3ForChartingOutstandingBalance =
        extractTextBetweeforloandetails(
          creditFile,
          "Aggregated Outstanding Balances for Preceding 5 Months",
          "Aggregated Monthly Instalment"
        );
      let chartDate = parseData(extract3ForChartingOutstandingBalance);

      const extract4ForChartingOutstandingBalance =
        extractTextBetweeforloandetails(
          textWithoutPage,
          "aggregated monthly instalment  month   product type   grantor bank   account type**   property***   non-property   unsecured  exempted unsecured  ",
          "aggregated monthly instalments for preceding 5 months"
        );

      const extractEnquiryDate = extractTextBetweeforloandetails(
        textWithoutPage,
        "enquiry date",
        "reference"
      );

      const extract8ForOverdueBalance = extractTextBetweeforloandetails(
        textWithoutPage,
        "account status history",
        "previous enquiries  date "
      )
        .replace(new RegExp(targetLine, "g"), " ") // Replace all occurrences of targetLine
        .replace(/account status history/g, "") // Replace all occurrences of the specific phrases
        .replace(/product type/g, "")
        .replace(/grantor bank/g, "")
        .replace(/account type/g, "")
        .replace(/date opened \/ date closed/g, "")
        .replace(/overdue balance/g, "")
        .replace(
          /last 12 cycles \/ cash advance \/ balance transfer full payment/g,
          ""
        )
        .trim(); // Trim any leading/trailing spaces

      const creditReportData = {
        EnquiryDate: extractEnquiryDate,
        SecuredCreditLimit:
          creditFile && creditFile !== ""
            ? parseFloat(
                extractTextBetween(
                  "Secured Credit Limit",
                  "Unsecured Credit Limit"
                ).replace(/,/g, "")
              )
            : null,
        UnsecuredCreditLimit:
          creditFile && creditFile !== ""
            ? parseFloat(
                extractTextBetween(
                  "Unsecured Credit Limit",
                  "Exempted Credit Limit"
                ).replace(/,/g, "")
              )
            : null,
        CreditScore:
          creditFile && creditFile !== ""
            ? parseFloat(
                extractTextBetween(
                  "financial institution.  Score",
                  "Risk Grade"
                )
              )
            : null,
        RiskGrade:
          creditFile && creditFile !== ""
            ? extractTextBetween("Risk Grade ", "Risk Grade Description", file)
            : null,
        ProbabilityofDefault:
          creditFile && creditFile !== ""
            ? parseFloat(
                extractTextBetween(
                  "Probability of Default ",
                  " For more details on the description"
                ).replace(/,/g, "")
              )
            : null,
        SecuredCreditUtilized:
          creditFile && creditFile !== ""
            ? extractTextBetween(
                "Total  ",
                " Aggregated Outstanding Balances for Preceding 5 Months",
                file
              )
                ?.split("  ")
                ?.map((num) => parseFloat(num.replace(/,/g, "")))[0]
            : null,
        UnsecuredCreditUtilized:
          creditFile && creditFile !== ""
            ? extractTextBetween(
                "Total  ",
                " Aggregated Outstanding Balances for Preceding 5 Months",
                file
              )
                ?.split("  ")
                ?.map((num) => parseFloat(num.replace(/,/g, "")))[1]
            : null,
        SecuredCreditUtilizationinpercentage:
          creditFile && creditFile !== ""
            ? (
                (extractTextBetween(
                  "Total  ",
                  " Aggregated Outstanding Balances for Preceding 5 Months"
                )
                  ?.split("  ")
                  ?.map((num) => parseFloat(num.replace(/,/g, "")))[0] /
                  parseFloat(
                    extractTextBetween(
                      "Secured Credit Limit",
                      "Unsecured Credit Limit",
                      file
                    )?.replace(/,/g, "")
                  )) *
                100
              )?.toFixed(2)
            : null,
        UnsecuredCreditUtilizationinpercentage:
          creditFile && creditFile !== ""
            ? (
                (extractTextBetween(
                  "Total  ",
                  " Aggregated Outstanding Balances for Preceding 5 Months"
                )
                  ?.split("  ")
                  ?.map((num) => parseFloat(num.replace(/,/g, "")))[1] /
                  parseFloat(
                    extractTextBetween(
                      "Unsecured Credit Limit",
                      "Exempted Credit Limit",
                      file
                    )?.replace(/,/g, "")
                  )) *
                100
              )?.toFixed(2)
            : null,
        MonthlyCommitment: (
          parseFloat(
            extract2ForMonthlyCommitment
              .trim()
              .split("   ")
              [
                extract2ForMonthlyCommitment.trim().split("   ").length - 4
              ]?.replace(/,/g, "")
          ) +
          parseFloat(
            extract2ForMonthlyCommitment
              .trim()
              .split("   ")
              [
                extract2ForMonthlyCommitment.trim().split("   ").length - 3
              ]?.replace(/,/g, "")
          )
        ).toLocaleString("en-US", {
          style: "currency",
          currency: "SGD",
        }),
        NoteworthyOngoingLoans:
          splitStringToRows(extract).filter(
            (row) =>
              row.includes("private residential purchase") ||
              row.includes("motor vehicle loan") ||
              row.includes("hdb loan")
          ) &&
          splitStringToRows(extract).filter(
            (row) =>
              row.includes("private residential purchase") ||
              row.includes("motor vehicle loan") ||
              row.includes("hdb loan")
          ).length !== 0
            ? splitStringToRows(extract).filter(
                (row) =>
                  row.includes("private residential purchase") ||
                  row.includes("motor vehicle loan") ||
                  row.includes("hdb loan")
              )
            : null,
        Last6MonthsGraphChartMaxData:
          getMaxValue(chartDate) && chartDate.reverse()
            ? getMaxValue(chartDate)
            : null,
        Last6MonthsGraphChartData:
          getMaxValue(chartDate) && chartDate.reverse()
            ? chartDate.reverse()
            : null,
        CBSImpLoanSupplementaryInstallment: combineSingleOrJoint(
          combinePrivateResidentialPurchase(
            splitExactlyTwoSpaces(extract4ForChartingOutstandingBalance)
          )
        ).filter(
          (row) =>
            row.includes("private residential purchase") ||
            row.includes("motor vehicle loan") ||
            row.includes("hdb loan")
        )
          ? combineSingleOrJoint(
              combinePrivateResidentialPurchase(
                splitExactlyTwoSpaces(extract4ForChartingOutstandingBalance)
              )
            ).filter(
              (row) =>
                row.includes("private residential purchase") ||
                row.includes("motor vehicle loan") ||
                row.includes("hdb loan")
            )
          : null,
        defaults: parseFloat(
          extractTextBetween("Defaults   ", "  Bankruptcy Proceedings   ")
        ),
        bankcruptcyProceedings: parseFloat(
          extractTextBetween(
            "  Bankruptcy Proceedings   ",
            "  Secured Credit Limit "
          )
        ),
        overdueBalance: hasOverdueBalance(
          formatAndMergeString(extract8ForOverdueBalance)
        ),
      };
      formData1.append("credit_report_data", JSON.stringify(creditReportData));

      formData1.append("user_id", `${activeUser.user_id}`);

      const updateBorrowerCreditReport = await fetch(
        "https://www.smart-lend.com/api/user/adminborrowerUpdateCreditReport",
        {
          method: "POST",
          headers: {
            Authorization: "Bearer " + Cookies.get("token"),
          },
          body: formData1,
        }
      );
      const updateBorrowerCreditReportasd =
        await updateBorrowerCreditReport.json();

      if (updateBorrowerCreditReport.status === 200) {
        // fetchData2();
        message.success("CBS Report updated");
        setModal5(false);
        setIsLoadingScreen(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const UniversaleUploadFile = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    // console.log(file);
    try {
      const response1 = await fetch(
        "https://www.smart-lend.com/api/file/uploadUniversalFile",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          body: formData,
        }
      );
      if (response1.status === 200) {
        const data = await response1.json();
        const blobUrl = data.url; // Assuming this is the URL you want to store
        // console.log(blobUrl);
        setAccountManagerDetails({
          ...accountManagerDetails,
          profile: blobUrl,
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const [notificationEmailField, setNotificationEmailField] = useState("");
  const [notificationEmailModalIsOpen, setNotificationEmailModalIsOpen] =
    useState(false);
  const [isSendingTestUniversalEmail, setIsSendingTestUniversalEmail] =
    useState(false);

  const updateUserNotificationEmailLocally = (userId, notificationEmail) => {
    const updateUser = (user) =>
      user?.user_id === userId
        ? { ...user, notification_email: notificationEmail }
        : user;

    const updateUserPayload = (payload) => {
      if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
        return payload;
      }

      return {
        ...payload,
        Borrower: Array.isArray(payload.Borrower)
          ? payload.Borrower.map(updateUser)
          : payload.Borrower,
        Lender: Array.isArray(payload.Lender)
          ? payload.Lender.map(updateUser)
          : payload.Lender,
      };
    };

    setActiveUser((currentUser) => updateUser(currentUser));
    setActiveUser2((currentUser) => updateUser(currentUser));
    setDataBorrower((currentBorrowers) => currentBorrowers.map(updateUser));
    setDataLender((currentLenders) => currentLenders.map(updateUser));
    setDataAll((currentData) => updateUserPayload(currentData));
    setDataAll2((currentData) => updateUserPayload(currentData));
  };

  const createTheLoanToLastStep = async () => {
    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/loan/createTheLoanToLastStep`,
        {
          method: "POST",
          headers: {
            Authorization: "Bearer " + Cookies.get("token"),
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            loan_id: conciergeCreatingLoanData.loan_id,
            lender_id: conciergeCreatingLoanData.lender_id,
            borrower_id: conciergeCreatingLoanData.borrower_id,
            lender_sign: 1,
            borrower_uploaded_agreement: 1,
            borrower_sign: 1,
            type: "simple",
            document: "done",
            express: 0,
            status: "ongoing",
            principal: (
              conciergeCreatingLoanData.amount +
              conciergeCreatingLoanData.amount *
                conciergeCreatingLoanData.interest_rate *
                conciergeCreatingLoanData.period
            ).toFixed(2),
            amount: conciergeCreatingLoanData.amount,
            admin_fee: 0,
            total_admin_fee: 0,
            interest_rate: conciergeCreatingLoanData.interest_rate,
            period: conciergeCreatingLoanData.period,
            monthly_installment: (
              (conciergeCreatingLoanData.amount +
                conciergeCreatingLoanData.amount *
                  conciergeCreatingLoanData.interest_rate *
                  conciergeCreatingLoanData.period) /
              conciergeCreatingLoanData.period
            ).toFixed(2),
            revenue:
              conciergeCreatingLoanData.amount *
              conciergeCreatingLoanData.interest_rate *
              conciergeCreatingLoanData.period,
            receipt: "done",
            authorization_required: 0,
            fees_collected: 0,
            processing_fee: conciergeCreatingLoanData.processing_fee,
            created_at: conciergeCreatingLoanData.created_at,
          }),
        }
      );
      if (response.status === 201) {
        try {
          const currentDate = new Date();
          const year = currentDate.getFullYear();
          const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // Months are 0-based, so we add 1 and pad with leading zero if needed
          const day = String(currentDate.getDate()).padStart(2, "0"); // Pad with leading zero if needed
          const loan_receive = `${year}-${month}-${day}`;
          const response = await fetch(
            `https://www.smart-lend.com/api/loan/createRepayManual`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Cookies.get("token")}`,
              },
              body: JSON.stringify({
                loan_id: conciergeCreatingLoanData.loan_id,
                loan_receive: loan_receive,
                user_id: conciergeCreatingLoanData.lender_id,
              }),
            }
          );

          if (response.status === 200) {
            message.success("Repayment schedule generated for borrower");
            message.success(
              `Loan ${conciergeCreatingLoanData.loan_id} status has been updated to ongoing`
            );
            message.success(`Borrower has been updated.`);
            setIsConciergeModalOpen(false);
            setModal3(false);
            setConciergeCreatingLoanData({
              loan_id: "",
              lender_id: "",
              borrower_id: "",
              lender_sign: 1,
              borrower_uploaded_agreement: 1,
              borrower_sign: 1,
              type: "simple",
              express: 0,
              status: "ongoing",
              principal: 0,
              amount: 0,
              admin_fee: 0,
              total_admin_fee: 0,
              interest_rate: 0,
              period: 0,
              monthly_installment: 0,
              revenue: 0,
              receipt: "done",
              authorization_required: 0,
              fees_collected: 0,
            });
          }
        } catch (error) {
          console.error("Error fetching receipt:", error);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const changeUserNotificationEmail = async (user_id, notification_email) => {
    const normalizedNotificationEmail = notification_email.trim();

    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/admin/changeUserNotificationEmail`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            user_id: user_id,
            notification_email: normalizedNotificationEmail,
          }),
        }
      );
      if (response.ok) {
        updateUserNotificationEmailLocally(
          user_id,
          normalizedNotificationEmail
        );
        setNotificationEmailField("");
        setNotificationEmailModalIsOpen(false);
        message.success("User Notifiable email updated!");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const sendTestUniversalEmail = async (user_id) => {
    if (!user_id || isSendingTestUniversalEmail) {
      return;
    }

    setIsSendingTestUniversalEmail(true);

    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/admin/sendTestUniversalEmail`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            user_id: user_id,
          }),
        }
      );
      const json = await response.json();

      if (response.ok) {
        message.success(
          json.receiver
            ? `Test universal email queued to ${json.receiver}`
            : "Test universal email queued!"
        );
      } else {
        message.error(json.message || "Unable to send test universal email");
      }
    } catch (error) {
      console.error(error);
      message.error("Unable to send test universal email");
    } finally {
      setIsSendingTestUniversalEmail(false);
    }
  };

  const getEmployee = async () => {
    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/employee/getEmployee`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const json = await response.json();
      setEmployeeList(json.employees);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchData = async () => {
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/user/getAllUser",
        {
          method: "GET",
          headers: {
            Authorization: "Bearer " + Cookies.get("token"),
            Accept: "application/json",
          },
        }
      );
      const json = await response.json();
      console.log("json:", json);
      setDataAll2(json);
      setDataAll(json);
      setDataLender(json["Lender"]);
      setDataBorrower(json["Borrower"]);
      setActiveUser(json["Borrower"][0]);
      setActiveUser2(json["Borrower"][0]);

      console.log("credit_report:", json["Borrower"]);
    } catch (error) {
      console.error(error);
    }
  };
  const [pageCountb, setPageCountb] = useState(1);
  const [activePageb, setActivePageb] = useState(1);
  const [pageCountl, setPageCountl] = useState(1);
  const [activePagel, setActivePagel] = useState(1);
  const [borrowerDataFilter, setBorrowerDataFilter] = useState("all");
  const [lenderProductFilter, setLenderProductFilter] = useState("all");
  const [lenderProductCounts, setLenderProductCounts] = useState({
    all: 0,
    personal: 0,
    corporate: 0,
    property: 0,
  });
  const [lenderProductsRevision, setLenderProductsRevision] = useState(0);
  const [borrowerDataCounts, setBorrowerDataCounts] = useState({
    all: 0,
    myinfo: 0,
    singpass: 0,
  });
  const [borrowerTotalCount, setBorrowerTotalCount] = useState(0);
  const [lenderTotalCount, setLenderTotalCount] = useState(0);

  const listUsersByCondition = async (
    page_lender,
    page_borrower,
    search,
    dataFilter,
    productFilter,
    signal
  ) => {
    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/superAdminSl/listUsers?page_lender=${page_lender}&page_borrower=${page_borrower}&search=${encodeURIComponent(
          search || ""
        )}&borrower_data_filter=${dataFilter || "all"}&lender_product_filter=${productFilter || "all"}`,
        {
          signal,
          method: "POST",
          headers: {
            Authorization: "Bearer " + Cookies.get("token"),
            Accept: "application/json",
          },
        }
      );
      if (!response.ok) throw new Error("Failed to search users");
      const json = await response.json();
      if (signal.aborted) return;
      console.log("json:", json);
      setDataAll2(json);
      setDataAll(json);
      setDataLender(json["Lender"]);
      setDataBorrower(json["Borrower"]);
      setActiveUser((currentUser) =>
        activeTab === "Lender"
          ? json["Lender"].find((lender) => lender.user_id === currentUser?.user_id) || json["Lender"][0]
          : json["Borrower"][0]
      );
      setActiveUser2(json["Borrower"][0]);
      if (activePageb > json.meta.borrower.total_pages) {
        setActivePageb(1);
      }
      if (activePagel > json.meta.lender.total_pages) {
        setActivePagel(1);
      }
      setPageCountb(json.meta.borrower.total_pages);
      setPageCountl(json.meta.lender.total_pages);
      setBorrowerTotalCount(json.meta.borrower.total);
      setLenderTotalCount(json.meta.lender.total);
      setLenderProductCounts(
        json.meta.lender.product_counts || {
          all: json.meta.lender.total,
          personal: 0,
          corporate: 0,
          property: 0,
        }
      );
      setBorrowerDataCounts(
        json.meta.borrower.data_counts || {
          all: json.meta.borrower.total,
          myinfo: 0,
          singpass: 0,
        }
      );

      console.log("credit_report:", json["Borrower"]);
    } catch (error) {
      if (error.name !== "AbortError") console.error(error);
    }
  };

  const paginationItems =
    activeTab === "Borrower"
      ? buildPaginationItems(activePageb, pageCountb)
      : buildPaginationItems(activePagel, pageCountl);

  const borrowerDataFilterOptions = [
    { label: "All users", value: "all" },
    { label: "MyInfo data", value: "myinfo" },
    { label: "Singpass data", value: "singpass" },
  ];
  const lenderProductFilterOptions = [
    ...lenderProductOptions,
    { label: "All", value: "all" },
  ];
  const userFilterOptions = activeTab === "Borrower"
    ? borrowerDataFilterOptions
    : lenderProductFilterOptions;
  const selectedUserFilter = activeTab === "Borrower"
    ? borrowerDataFilter
    : lenderProductFilter;
  const userFilterCounts = activeTab === "Borrower"
    ? borrowerDataCounts
    : lenderProductCounts;

  const updateLenderAllowedProducts = async (lenderId, allowedProducts) => {
    const response = await fetch(
      "https://www.smart-lend.com/api/lender/updateAllowedProducts",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + Cookies.get("token"),
          Accept: "application/json",
        },
        body: JSON.stringify({
          user_id: lenderId,
          allowed_products: allowedProducts,
        }),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to update allowed products");
    }

    return response.json();
  };

  useEffect(() => {
    const controller = new AbortController();
    listUsersByCondition(
      activePagel,
      activePageb,
      paramValue,
      borrowerDataFilter,
      lenderProductFilter,
      controller.signal
    );
    return () => controller.abort();
  }, [activeTab, activePageb, activePagel, paramValue, borrowerDataFilter, lenderProductFilter, lenderProductsRevision]);

  const setAccountManager = async (dataTosend) => {
    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/user/setAccountManager`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + Cookies.get("token"),
          },
          body: JSON.stringify(dataTosend),
        }
      );
      const json = await response.json();
      if (response.status === 200) {
        message.success("Account Manager updated");
        // fetchData2();
        setAccountManagerModalIsOpen(false);

        setAccountManagerDetails({
          profile: "",
          name: "",
          ph: "",
          email: "",
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getEmployee();
  }, []);

  useEffect(() => {
    console.log(searchTerm);
  }, [searchTerm]);

  const getEmployeeName = (eid) => {
    if (eid === "cbs") {
      return "CBS Campaign";
    } else {
      if (eid && employeeList.length > 0) {
        const employeeIndex = employeeList.findIndex(
          (employee) => employee.id === parseFloat(eid)
        );
        if (employeeIndex !== -1) {
          return employeeList[employeeIndex]?.name
            ? employeeList[employeeIndex]?.name.length > 10
              ? employeeList[employeeIndex]?.name.slice(0, 10) + "..."
              : employeeList[employeeIndex]?.name
            : "Web";
        } else {
          return "Web";
        }
      } else {
        return "Web";
      }
    }
  };

  const availableTab = [
    { name: "Personal Information" },
    { name: "Corporate Information" },
    { name: "NOA History" },
    { name: "Capitals" },
    { name: "Financials" },
    { name: "Shareholders" },
    { name: "Borrower Report" },
  ];

  const singpassDetails = async (
    user,
    other_authorization,
    loan_id,
    keyman
  ) => {
    try {
      setKeyman(keyman);
      const response = await fetch(
        `https://www.smart-lend.com/api/user/getBorrowerSingppass?user_id=${user}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );

      const json = await response.json();
      let allSingpassData = [json.singpass_data];
      setDataSingpassModal(true);
      setMyinfoData(json.singpass_data ? null : json.myinfo_data || null);
      if (other_authorization) {
        console.log("need other authorizer");
        setNeedOtherAuthoriser(true);
        try {
          const response2 = await fetch(
            `https://www.smart-lend.com/api/loanDetails/getLoanAuthorisers`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Cookies.get("token")}`,
              },
              body: JSON.stringify({ loan_id: loan_id }),
            }
          );

          const json2 = await response2.json();
          setOtherAuthoriserDetails(json2.authorisers);
          console.log(JSON.parse(json2.authorisers[0].singpass_data));
          console.log(json.singpass_data);
          setLiveUserData(json.singpass_data);
          console.log(json2.authorisers);

          for (const single of json2.authorisers) {
            allSingpassData.push(JSON.parse(single.singpass_data));
          }
        } catch (error) {
          console.error(error);
        }
      } else {
        console.log("Doesnt need other authoriser");
        setLiveUserData(json.singpass_data);
        setNeedOtherAuthoriser(false);
        setOtherAuthoriserDetails(null);
      }
      if (json.singpass_data) {
        setSingpassData(json.singpass_data);
        console.log(allSingpassData);
        setCombinedSingpassData(allSingpassData);
      } else {
        setSingpassData(null);
        setCombinedSingpassData([]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleBorrowerViewDetails = () => {
    if (!activeUser) return;

    const singpassPayload = parseMaybeJson(activeUser?.singpass_data);
    const myinfoPayload = parseMaybeJson(activeUser?.myinfo_data);
    if (!singpassPayload && !myinfoPayload) return;

    setBadgeVerified(activeUser.badge_verified);
    setBackupContact(activeUser.user_id);
    setViewingTab(0);
    setViewingUser(0);
    setNeedOtherAuthoriser(false);
    setOtherAuthoriserDetails(null);

    const cbsData = parseMaybeJson(activeUser.credit_report_data) || {};
    setAllCBSData([
      {
        name:
          getPersonData(singpassPayload)?.name?.value ||
          myinfoPayload?.name?.value ||
          getPersonData(myinfoPayload)?.name?.value ||
          getBorrowerDisplayName(activeUser),
        cbs_data: cbsData,
      },
    ]);

    if (singpassPayload) {
      setMyinfoData(null);
      if (activeUser.loanRequest.length > 0) {
        singpassDetails(
          activeUser.user_id,
          activeUser.loanRequest[activeUser.loanRequest.length - 1]
            .authorization_required,
          activeUser.loanRequest[activeUser.loanRequest.length - 1].loan_id,
          activeUser.loanRequest[activeUser.loanRequest.length - 1].keyman
        );
      } else {
        singpassDetails(activeUser.user_id);
      }
      return;
    }

    setDataSingpassModal(true);
    setKeyman("");
    setSingpassData(null);
    setCombinedSingpassData([]);
    setLiveUserData(null);
    setMyinfoData(myinfoPayload);
  };
  const getShareholderAddress = (data) => {
    const allSingpassData = [singpassData];
    if (otherAuthoriserDetails !== null && otherAuthoriserDetails.length > 0) {
      for (const single of otherAuthoriserDetails) {
        allSingpassData.push(JSON.parse(single.singpass_data));
      }
      const toPush = allSingpassData.filter(
        (sd) => getPersonData(sd)?.name?.value === data
      );
      // console.log(toPush);
      return toPush;
    } else {
      return allSingpassData;
    }
  };
  const [lenderProfileData, setLenderProfileData] = useState(null);

  const markAsConcierge = async (mark, loan_id) => {
    // console.log(mark, loan_id)
    try {
      const response1 = await fetch(
        "https://www.smart-lend.com/api/loan/markAsConcierge",
        {
          method: "POST",
          body: JSON.stringify({ loan_id: loan_id, mark, mark: mark }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );

      const json = await response1.json();
      if (response1.status === 200) {
        message.success("Loan Concierge Updated!");
        setModal3(false);
        // fetchData2();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleGetLenderProfile = async (lender_id) => {
    try {
      const response1 = await fetch(
        "https://www.smart-lend.com/api/user/getLenderProfileDesign",
        {
          method: "POST",
          body: JSON.stringify({ user_id: lender_id }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );

      const json = await response1.json();
      if (json.design !== null) {
        if (isEqual(JSON.parse(json.design), lenderProfileData)) {
          setLenderProfileData(null);
        } else {
          setLenderProfileData(JSON.parse(json.design));
        }
      } else {
        setLenderProfileData(null);
      }
    } catch (error) {
      console.error(error);
    }
  };

  function hasLateDays(loan, threshold) {
    console.log("loan value:", loan);
    console.log("threshold value:", threshold);
    if (!loan.repaymentSchedule) return false;
    for (let schedule of loan.repaymentSchedule) {
      console.log("schedule status:", schedule.status);
      if (getRepaymentStatus(schedule) === "pending" && schedule.late_day > threshold) {
        return true;
      }
    }
    return false; // Return false if no matching schedule is found
  }

  function getCurrentDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are 0-based, so +1 and pad with a 0 if needed
    const day = String(today.getDate()).padStart(2, "0"); // Pad with a 0 if needed

    return `${year}-${month}-${day}`;
  }

  function hasAlmostThreeDay(loan, todayDate) {
    console.log("loan value:", loan);
    console.log("todayDate value:", todayDate);
    if (!loan.repaymentSchedule) return false;

    // Convert todayDate string into a Date object
    const today = new Date(todayDate);

    for (let schedule of loan.repaymentSchedule) {
      console.log("schedule status:", schedule.status);

      // Convert schedule.repay_due_date string into a Date object
      const dueDate = new Date(schedule.repay_due_date);
      console.log("dueDate:", dueDate);
      // Calculate the difference in days
      const diffInDays = Math.ceil((dueDate - today) / (1000 * 60 * 60 * 24));
      console.log("diffInDays:", diffInDays);
      if (getRepaymentStatus(schedule) === "pending" && diffInDays <= 3) {
        return true;
      }
    }
    return false; // Return false if no matching schedule is found
  }

  const handleDownloadCreditReport = async (userId, event) => {
    event.preventDefault();
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + Cookies.get("token"));

    const options = {
      method: "GET",
      headers: headers,
    };

    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/user/viewCreditReport?user_id=${userId}`,
        options
      );

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;

      // the filename you want
      a.download = "CreditReport.pdf"; // You can dynamically set the filename based on content-disposition header or any other logic

      document.body.appendChild(a);
      a.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error(error);
    }
  };

  // useEffect(() => {
  //   fetchData();
  // }, []);

  const [vpntoaccountuserId, setVpntoaccountuserId] = useState(null);
  const [otpPin, setOtpPin] = useState("");
  const [otpModalIsOpen, setOtpModalIsOpen] = useState(false);

  const createVPNPin = async () => {
    try {
      const response = await fetch("https://www.smart-lend.com/api/vpn/createpin", {
        method: "POST",
        headers: {
          Authorization: "Bearer " + Cookies.get("token"),
          Accept: "application/json",
        },
      });

      if (response.status === 200) {
        message.success("OTP have been sent to Roy.");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const validatePassword = async () => {
    try {
      const formData = new FormData();
      formData.append("otp", otpPin);
      const response = await fetch(
        "https://www.smart-lend.com/api/vpn/validatepin",
        {
          method: "POST",
          headers: {
            Authorization: "Bearer " + Cookies.get("token"),
            Accept: "application/json",
          },
          body: formData,
        }
      );

      if (response.status === 200) {
        message.success("Otp is valid.");
        vpnToAccount(vpntoaccountuserId);
      } else {
        message.error("Otp is invalid.");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const vpnToAccount = async (user_id) => {
    try {
      const formData = new FormData();
      formData.append("userId", user_id);

      const response = await fetch(
        "https://www.smart-lend.com/api/admin/vpnToUserAccount",
        {
          method: "POST",
          headers: {
            Authorization: "Bearer " + Cookies.get("token"),
            Accept: "application/json",
          },
          body: formData,
        }
      );

      const json = await response.json();
      if (response.status === 200) {
        Cookies.set("vpnToAccount", "true");
        if (json.user.user_account_type === "lender") {
          Cookies.set("token", json.token);
          Cookies.set("user_account_type", "lender");
          window.location.href = "https://smart-lend.com/dashboard";
        } else {
          Cookies.set("token", json.token);
          Cookies.set("user_account_type", "borrower");
          window.location.href = "https://smart-lend.com/b-dashboard";
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await fetch(
  //         "https://www.smart-lend.com/api/guest/getEmailSubcription",
  //         {
  //           method: "GET",
  //           headers: {
  //             Authorization: "Bearer " + Cookies.get("token"),
  //             Accept: "application/json",
  //           },
  //         }
  //       );
  //       const json = await response.json();
  //       console.log("json:", json);
  //       setDataAll2(json);
  //       // setDataLender(json["Lender"]);
  //       // setDataBorrower(json["Borrower"]);
  //       // setActiveUser(json["Borrower"][0]);
  //       // setActiveUser2(json["Borrower"][0]);
  //       setDataSubscribedEmail(json);
  //     } catch (error) {
  //       console.error(error);
  //     }
  //   };
  //   fetchData();
  // }, []);

  const addressFormatter = (value) => {
    if (value) {
      const dateParts = value.split("-");
      if (dateParts.length === 3) {
        const day = dateParts[2].split(" ")[0];
        const month = dateParts[1];
        const year = dateParts[0];

        // Map month numbers to month names (e.g., '09' => 'Sep')
        const monthNames = {
          "01": "Jan",
          "02": "Feb",
          "03": "Mar",
          "04": "Apr",
          "05": "May",
          "06": "Jun",
          "07": "Jul",
          "08": "Aug",
          "09": "Sep",
          10: "Oct",
          11: "Nov",
          12: "Dec",
        };

        // Format the date (e.g., '19 Sep' or '30 Dec')
        const formattedDate = `${monthNames[month]} ${day}, ${year}`;

        return formattedDate;
      }

      // Return the original value if it doesn't match the expected format
      return value;
    } else {
      return null;
    }
  };

  const options = { day: "numeric", month: "short", year: "numeric" };
  const currentDate = new Date();

  function getSanitizedUserInfo(activeUser) {
    const excludedProperties = ["loanOffers", "subscription", "password"];

    if (activeUser) {
      let sanitizedData = {};
      Object.entries(activeUser).forEach(([key, value]) => {
        if (!excludedProperties.includes(key)) {
          sanitizedData[key] = value;
        }
      });
      return sanitizedData;
    }
    return null;
  }

  function prepareDataForExcel(userType, data) {
    let result = [];

    if (data[userType]) {
      // Add user basic info
      result = [...data[userType]];

      // Add loanAccepted
      if (data.loanAccepted) {
        result = [...result, ...data.loanAccepted];
      }

      // Add loanRequest for Borrower
      if (userType === "Borrower" && data.loanRequest) {
        result = [...result, ...data.loanRequest];
      }

      // Add singpass_data if it exists and for Borrower
      if (userType === "Borrower" && data.singpass_data) {
        if (data.singpass_data.entity) {
          result = [...result, ...data.singpass_data.entity];
        }
        if (getPersonData(data.singpass_data)) {
          result = [...result, ...getPersonData(data.singpass_data)];
        }
      }
    }
    return result;
  }

  function renderUserInfo(activeUser) {
    // Define an array of properties to exclude from display
    const excludedProperties = [
      "loanOffers",
      "subscription",
      "id",
      "password",
      "singpass_data",
      "loanRequest",
      "loanAccepted",
      "singpass_data_backup",
    ];
    if (activeUser) {
      return Object.entries(activeUser).map(([key, value]) => {
        // Check if the property is excluded
        if (excludedProperties.includes(key)) {
          return null; // Skip this property
        }

        // Check if the value is a JSON string (e.g., subscription)
        if (
          typeof value === "string" &&
          value.startsWith("{") &&
          value.endsWith("}")
        ) {
          try {
            value = JSON.parse(value);
          } catch (error) {
            // Handle JSON parse error (optional)
          }
        }

        // Render the label and value
        return (
          <div key={key} style={{ width: "23%" }}>
            <div>{key}:</div>
            <div
              style={{
                color: "#142C44CC",
                fontSize: "15px",
                fontFamily: "Poppins, sans-serif",
                fontWeight: "600",
                margin: "0px 0px 10px 0px",
              }}
            >
              {typeof value === "object" ? JSON.stringify(value) : value}
            </div>
          </div>
        );
      });
    }
  }

  const formatWizardList = (items) => {
    if (!items || items.length === 0) return "—";
    return items.join(", ");
  };

  const fetchWelcomeWizardResponse = async (userid) => {
    if (!userid) {
      setWelcomeWizardResponse(null);
      setWelcomeWizardError(null);
      setHasLoadedWelcomeWizard(false);
      return;
    }

    setIsWelcomeWizardLoading(true);
    setWelcomeWizardError(null);

    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/admin/welcome-wizard?user_id=${userid}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + Cookies.get("token"),
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch welcome wizard response");
      }

      const data = await response.json();
      setWelcomeWizardResponse(data.response || null);
      setHasLoadedWelcomeWizard(true);
    } catch (error) {
      console.error(error);
      setWelcomeWizardError(
        "Unable to load welcome wizard responses right now."
      );
      setWelcomeWizardResponse(null);
      setHasLoadedWelcomeWizard(true);
    } finally {
      setIsWelcomeWizardLoading(false);
    }
  };

  const renderWelcomeWizardResponse = () => {
    if (isWelcomeWizardLoading) {
      return <div>Loading welcome wizard responses...</div>;
    }

    if (welcomeWizardError) {
      return (
        <div style={{ color: "rgba(220,38,38,0.8)" }}>{welcomeWizardError}</div>
      );
    }

    if (!hasLoadedWelcomeWizard) {
      return (
        <div style={{ color: "rgba(0,0,0,0.6)" }}>
          Click “Load responses” to view the borrower’s welcome wizard answers.
        </div>
      );
    }

    if (!welcomeWizardResponse) {
      return <div>No welcome wizard responses recorded.</div>;
    }

    return (
      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <div>
          <div style={{ color: "rgba(0,0,0,0.5)" }}>Signup reason</div>
          <div style={{ fontSize: "13px" }}>
            {welcomeWizardResponse.signup_reason || "—"}
          </div>
        </div>
        <div>
          <div style={{ color: "rgba(0,0,0,0.5)" }}>Personal goals</div>
          <div style={{ fontSize: "13px" }}>
            {formatWizardList(welcomeWizardResponse.personal_goals)}
          </div>
          {welcomeWizardResponse.personal_other_text ? (
            <div style={{ fontSize: "12px", marginTop: "4px" }}>
              Other: {welcomeWizardResponse.personal_other_text}
            </div>
          ) : null}
        </div>
        <div>
          <div style={{ color: "rgba(0,0,0,0.5)" }}>Business goals</div>
          <div style={{ fontSize: "13px" }}>
            {formatWizardList(welcomeWizardResponse.business_goals)}
          </div>
          {welcomeWizardResponse.business_other_text ? (
            <div style={{ fontSize: "12px", marginTop: "4px" }}>
              Other: {welcomeWizardResponse.business_other_text}
            </div>
          ) : null}
        </div>
        <div>
          <div style={{ color: "rgba(0,0,0,0.5)" }}>CBS reason</div>
          <div style={{ fontSize: "13px" }}>
            {welcomeWizardResponse.cbs_reason || "—"}
          </div>
        </div>
      </div>
    );
  };

  // Usage in your component
  <div>{activeUser ? renderUserInfo(activeUser) : null}</div>;

  function exportToExcel(data) {
    if (data) {
      const wb = XLSX.utils.book_new(); // Create a new workbook

      // Sheet for main user info
      const mainUserInfo = { ...data };
      delete mainUserInfo.singpass_data;
      delete mainUserInfo.loanRequest;
      delete mainUserInfo.loanAccepted;
      const mainWs = XLSX.utils.json_to_sheet([mainUserInfo]);
      XLSX.utils.book_append_sheet(wb, mainWs, "UserInfo");
      // Sheet for singpass_data
      if (data.singpass_data) {
        const singpassWs = XLSX.utils.json_to_sheet([
          flattenObject(data.singpass_data),
        ]);
        console.log(flattenObject(singpassWs), singpassWs);
        XLSX.utils.book_append_sheet(wb, singpassWs, "SingPass Data");
      }

      // Sheet for loanRequest
      if (data.loanRequest && data.loanRequest.length) {
        const loanRequestWs = XLSX.utils.json_to_sheet(data.loanRequest);
        console.log(loanRequestWs);
        XLSX.utils.book_append_sheet(wb, loanRequestWs, "Loan Requests");
      }

      // Sheet for loanAccepted
      if (data.loanAccepted && data.loanAccepted.length) {
        const loanAcceptedWs = XLSX.utils.json_to_sheet(data.loanAccepted);
        XLSX.utils.book_append_sheet(wb, loanAcceptedWs, "Loans Accepted");
      }

      XLSX.writeFile(wb, "user_info.xlsx"); // Save the workbook as an Excel file
    }
  }

  function exportToEmailSubscribed(data) {
    // Create a new array without the 'created_at' and 'updated_at' properties
    const filteredData = data.map(
      ({ created_at, updated_at, ...item }) => item
    );

    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Convert the filtered data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(filteredData);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Subscribed Emails");

    // Generate an Excel file
    XLSX.writeFile(workbook, "SubscribedEmails.xlsx");
  }

  function getBorrowerInfo(data) {
    console.log("dataGetBorrower:", data.Borrower);

    // Initialize an array to hold the processed borrower information
    let processedBorrowers = [];

    // Iterating over each borrower in the Borrower array
    data.Borrower.forEach((borrower, index) => {
      console.log(`Borrower ${index}:`, borrower);

      // Check if loanAccepted and loanRequest exist and are arrays for each borrower
      const loanAccepted = Array.isArray(borrower.loanAccepted)
        ? borrower.loanAccepted
        : [];
      const loanRequest = Array.isArray(borrower.loanRequest)
        ? borrower.loanRequest
        : [];

      // Logging the contents of loanAccepted and loanRequest arrays for each borrower
      console.log(
        `Borrower ${index} Loan Accepted:`,
        loanAccepted.length > 0 ? loanAccepted : "No data"
      );
      console.log(
        `Borrower ${index} Loan Request:`,
        loanRequest.length > 0 ? loanRequest : "No data"
      );

      // Collecting processed borrower data
      processedBorrowers.push({
        Borrower: borrower,
        loanAccepted: loanAccepted,
        loanRequest: loanRequest,
        singpass_data_entity: borrower.singpass_data
          ? borrower.singpass_data.entity
          : null,
        singpass_data_person: borrower.singpass_data
          ? getPersonData(borrower.singpass_data)
          : null,
      });
    });

    // Return the processed borrower information
    return processedBorrowers;
  }

  function getLenderInfo(data) {
    console.log("dataGetLender:", data.Lender);

    // Initialize an array to hold the processed lender information
    let processedLender = [];

    // Iterating over each lender in the Lender array
    data.Lender.forEach((lender, index) => {
      console.log(`Lender ${index}:`, lender);

      // Check if loanAccepted and loanOffers exist and are arrays for each lender
      const loanAccepted = Array.isArray(lender.loanAccepted)
        ? lender.loanAccepted
        : [];
      const loanOffers = Array.isArray(lender.loanOffers)
        ? lender.loanOffers
        : [];

      // Logging the contents of loanAccepted and loanOffers arrays for each lender
      console.log(
        `Lender ${index} Loan Accepted:`,
        loanAccepted.length > 0 ? loanAccepted : "No data"
      );
      console.log(
        `Lender ${index} Loan Offered:`,
        loanOffers.length > 0 ? loanOffers : "No data"
      );

      // Collecting processed lender data
      processedLender.push({
        Lender: lender,
        loanAccepted: loanAccepted,
        loanOffers: loanOffers,
        singpass_data_entity: lender.singpass_data
          ? lender.singpass_data.entity
          : null,
        singpass_data_person: lender.singpass_data
          ? getPersonData(lender.singpass_data)
          : null,
      });
    });

    // Return the processed lender information
    return processedLender;
  }
  function flattenObject(obj, parentKey = "", result = {}) {
    if (Array.isArray(obj)) {
      obj.forEach((item, index) => {
        flattenObject(item, `${parentKey}[${index}]`, result);
      });
    } else {
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          let propName = parentKey ? `${parentKey}_${key}` : key;

          if (typeof obj[key] === "object" && obj[key] !== null) {
            flattenObject(obj[key], propName, result);
          } else {
            result[propName] = obj[key];
          }
        }
      }
    }
    return result;
  }

  function exportToExcelAllInfo(processedData, userType) {
    console.log("userType: ", userType);
    console.log(processedData);
    if (processedData && processedData.length > 0) {
      const wb = XLSX.utils.book_new(); // Create a new workbook

      // Sheet for basic borrower/lender info
      const baseData = processedData.map(
        (item) => item.Borrower || item.Lender
      );

      let updatedFlattenedBaseData = [];

      for (const base of baseData) {
        const flattenedObject = flattenObject(base);
        updatedFlattenedBaseData.push(flattenedObject);
      }
      const baseWs = XLSX.utils.json_to_sheet(updatedFlattenedBaseData);
      XLSX.utils.book_append_sheet(wb, baseWs, `${userType} Info`);
      console.log(baseData, updatedFlattenedBaseData, baseWs);

      // Sheets for loanAccepted, loanRequest, singpass_data (entity and person)
      processedData.forEach((item, index) => {
        if (item.loanAccepted && item.loanAccepted.length > 0) {
          const loanAcceptedWs = XLSX.utils.json_to_sheet(item.loanAccepted);
          XLSX.utils.book_append_sheet(
            wb,
            loanAcceptedWs,
            `Loan Accepted ${index}`
          );
        }

        if (
          userType === "Borrower" &&
          item.loanRequest &&
          item.loanRequest.length > 0
        ) {
          const loanRequestWs = XLSX.utils.json_to_sheet(item.loanRequest);
          XLSX.utils.book_append_sheet(
            wb,
            loanRequestWs,
            `Loan Request ${index}`
          );
        }

        // New code for loanOffers (specific to Lender)
        if (
          userType === "Lender" &&
          item.loanOffers &&
          item.loanOffers.length > 0
        ) {
          const loanOffersWs = XLSX.utils.json_to_sheet(item.loanOffers);
          XLSX.utils.book_append_sheet(
            wb,
            loanOffersWs,
            `Loan Offers ${index}`
          );
        }

        if (userType === "Borrower" && item.singpass_data) {
          if (item.singpass_data.entity) {
            const entityWs = XLSX.utils.json_to_sheet([
              item.singpass_data.entity,
            ]);
            console.log(entityWs);
            XLSX.utils.book_append_sheet(
              wb,
              entityWs,
              `SingPass Entity Data ${index}`
            );
          }
          if (getPersonData(item.singpass_data)) {
            const personWs = XLSX.utils.json_to_sheet([
              getPersonData(item.singpass_data),
            ]);
            console.log(personWs);
            XLSX.utils.book_append_sheet(
              wb,
              personWs,
              `SingPass Person Data ${index}`
            );
          }
        }
      });

      XLSX.writeFile(wb, `${userType}_info.xlsx`); // Save the workbook as an Excel file
    } else {
      console.error("No data available to export.");
    }
  }

  function renderLoanAcceptedInfo(loan) {
    // Define an array of properties to exclude from display
    const excludedProperties = ["repaymentSchedule"];
    if (loan) {
      return Object.entries(loan).map(([key, value]) => {
        // Check if the property is excluded
        if (excludedProperties.includes(key)) {
          return null; // Skip this property
        }
        return (
          <div key={key} style={{ width: "45%" }}>
            <div>{key}:</div>
            <div
              style={{
                color: "#142C44CC",
                fontSize: "15px",
                fontFamily: "Poppins, sans-serif",
                fontWeight: "600",
                margin: "0px 0px 10px 0px",
              }}
            >
              {typeof value === "object" ? JSON.stringify(value) : value}
            </div>
          </div>
        );
      });
    }
    return null;
  }
  const [isMobile, setIsMobile] = useState(
    Cookies.get("ismobile") === "yes" ? true : false
  );

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    // Call handleResize initially to set the initial screen width
    handleResize();

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    if (screenWidth < 1200) {
      Cookies.set("ismobile", "yes");
      setIsMobile(true);
    } else {
      Cookies.set("ismobile", "no");
      setIsMobile(false);
    }
  }, [screenWidth]);

  const getNamesFromArray = (data) => {
    if (!data || data.length === 0) {
      return <div>None at the moment</div>;
    } else {
      // console.log(data);
      return (
        <div>
          {data.map((userId, index) => {
            const match = dataLender.find(
              (lender) => lender?.user_id === userId
            );
            return (
              <div key={index}>
                {match ? match?.principal_name : "Unknown User"}
              </div>
            );
          })}
        </div>
      );
    }
  };

  function renderLoanInfo(loan) {
    if (loan) {
      return Object.entries(loan).map(([key, value]) => {
        return (
          <div key={key} style={{ width: "45%" }}>
            <div>{key}:</div>
            <div
              style={{
                color: "#142C44CC",
                fontSize: "15px",
                fontFamily: "Poppins, sans-serif",
                fontWeight: "600",
                margin: "0px 0px 10px 0px",
              }}
            >
              {key === "viewed_by" ||
              key === "express_interest" ||
              key === "download_by"
                ? getNamesFromArray(JSON.parse(value))
                : typeof value === "object"
                ? JSON.stringify(value)
                : value}
              {/* {typeof value === "object" ? JSON.stringify(value) : value} */}
            </div>
          </div>
        );
      });
    }
    return null;
  }

  // Usage in your component
  // <div>{activeUser ? renderLoanAcceptedInfo(activeUser) : null}</div>;

  const [resetPassword, setResetPassword] = useState("");

  const adminResetPassword = async (email) => {
    try {
      const formData = new FormData();
      formData.append("email", email);
      formData.append("password", resetPassword);
      const response = await fetch(
        "https://www.smart-lend.com/api/admin/passwordreset",
        {
          method: "POST",
          body: formData,
        }
      );
      const json = await response.json();
      if (response.status === 200) {
        console.log(json);
        setModal4(false);
        setResetPassword("");
        message.success("Password has been changed");
      } else {
        message.error("Something went wrong");
      }
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <div
      style={{
        width: "100%",
        height: "91vh",
        display: "flex",
        justifyContent: "space-betweeen",
        gap: "20px",
      }}
    >
      {isLoadingScreen ? (
        <div
          style={{
            background: "rgba(256,256,256,0.4)",
            height: window.innerHeight,
            width: window.innerWidth,
            position: "fixed",
            top: 0,
            left: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2000,
          }}
        >
          <CircularProgress size={"5rem"} />
        </div>
      ) : null}
      <Modal
        width={"60%"}
        style={{ backgroundColor: "rgba(0, 0, 0, 0)" }}
        open={isConciergeModalOpen}
        onCancel={() => {
          setIsConciergeModalOpen(false);
          setConciergeCreatingLoanData({
            loan_id: "",
            lender_id: "",
            borrower_id: "",
            lender_sign: 1,
            borrower_uploaded_agreement: 1,
            borrower_sign: 1,
            type: "simple",
            express: 0,
            status: "ongoing",
            principal: 0,
            amount: 0,
            admin_fee: 0,
            total_admin_fee: 0,
            interest_rate: 0,
            period: 0,
            monthly_installment: 0,
            revenue: 0,
            receipt: "done",
            authorization_required: 0,
            fees_collected: 0,
          });
        }}
        footer={null}
      >
        <div
          style={{
            color: "#142C44CC",
            fontSize: "18px",
            fontFamily: "Manrope, sans-serif",
            fontWeight: "800",
          }}
        >
          Create Loan Manually
        </div>
        <hr style={{ width: "95%" }} />
        <div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
          <div style={{ width: "45%" }}>
            <div style={{ color: "grey", fontSize: "10px" }}>Select Lender</div>
            <select
              style={{
                border: "1px solid lightgrey",
                borderRadius: "20px",
                padding: "6px 12px",
                width: "95%",
              }}
              value={conciergeCreatingLoanData.lender_id}
              onChange={(e) => {
                console.log(e.target.value);
                setConciergeCreatingLoanData({
                  ...conciergeCreatingLoanData,
                  lender_id: e.target.value,
                });
              }}
            >
              <option value={""}>Select a Lender</option>
              {dataLender.map((len, index) => (
                <option value={len.user_id} key={index}>
                  {len.principal_name}
                </option>
              ))}
            </select>
          </div>
          <div style={{ width: "45%" }}>
            <div style={{ color: "grey", fontSize: "10px" }}>Loan Amount</div>
            <InputNumber
              style={{
                border: "1px solid lightgrey",
                borderRadius: "20px",
                padding: "1px 12px",
                width: "95%",
              }}
              value={conciergeCreatingLoanData.amount}
              onChange={(e) => {
                console.log(e);
                setConciergeCreatingLoanData({
                  ...conciergeCreatingLoanData,
                  amount: e,
                });
              }}
              formatter={(value) =>
                value
                  ? `$ ${value}`
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      .toLocaleString("en-US", {
                        style: "currency",
                        currency: "SGD",
                      })
                  : ""
              }
              parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
            />
          </div>
          <div style={{ width: "45%" }}>
            <div style={{ color: "grey", fontSize: "10px" }}>
              Loan Period (Months)
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
              <input
                style={{
                  border: "1px solid lightgrey",
                  borderRadius: "20px",
                  padding: "6px 12px",
                  width: "40%",
                }}
                value={conciergeCreatingLoanData.period}
                onChange={(e) => {
                  console.log(e.target.value);
                  setConciergeCreatingLoanData({
                    ...conciergeCreatingLoanData,
                    period: e.target.value,
                  });
                }}
              />{" "}
              Months{" "}
            </div>
          </div>
          <div style={{ width: "45%" }}>
            <div style={{ color: "grey", fontSize: "10px" }}>
              Interest Rate (%)
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
              <input
                style={{
                  border: "1px solid lightgrey",
                  borderRadius: "20px",
                  padding: "6px 12px",
                  width: "40%",
                }}
                value={conciergeCreatingLoanData.input_interest_rate}
                onChange={(e) => {
                  console.log(e.target.value / 100);
                  setConciergeCreatingLoanData({
                    ...conciergeCreatingLoanData,
                    input_interest_rate: e.target.value,
                    interest: e.target.value / 100,
                  });
                }}
              />{" "}
              %{" "}
            </div>
          </div>
          <div style={{ width: "45%" }}>
            <div style={{ color: "grey", fontSize: "10px" }}>
              Processing Fee (%)
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
              <input
                style={{
                  border: "1px solid lightgrey",
                  borderRadius: "20px",
                  padding: "6px 12px",
                  width: "40%",
                }}
                value={conciergeCreatingLoanData.input_processing_fee}
                onChange={(e) => {
                  console.log(e.target.value / 100);
                  setConciergeCreatingLoanData({
                    ...conciergeCreatingLoanData,
                    input_processing_fee: e.target.value,
                    processing_fee: e.target.value / 100,
                  });
                }}
              />{" "}
              %{" "}
            </div>
          </div>
          <div style={{ width: "45%" }}>
            <div style={{ color: "grey", fontSize: "10px" }}>
              Disbursement Date
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
              <input
                type="date"
                style={{
                  border: "1px solid lightgrey",
                  borderRadius: "20px",
                  padding: "6px 12px",
                  width: "95%",
                }}
                value={conciergeCreatingLoanData.created_at}
                onChange={(e) => {
                  console.log(e.target.value);
                  setConciergeCreatingLoanData({
                    ...conciergeCreatingLoanData,
                    created_at: e.target.value,
                  });
                }}
              />
            </div>
          </div>
        </div>
        {conciergeCreatingLoanData.lender_id !== "" &&
        conciergeCreatingLoanData.amount !== 0 &&
        conciergeCreatingLoanData.period !== 0 &&
        conciergeCreatingLoanData.input_interest_rate !== 0 &&
        conciergeCreatingLoanData.input_interest_rate !== 0 &&
        conciergeCreatingLoanData.created_at !== "" ? (
          <div style={{ display: "flex", marginTop: "20px" }}>
            <div
              className="mui_button"
              style={{
                border: "none",
                borderRadius: "50px",
                padding: "10px 35px",
                fontSize: "12px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "#ffffff",
                background: "linear-gradient(90deg, #206be3 0%, #d413c7 100%)",
                outline: "1px solid lightgrey",
                gap: "8px",
              }}
              onClick={() => {
                // console.log(conciergeCreatingLoanData);
                createTheLoanToLastStep();
              }}
            >
              Create Loan
              <AutoAwesomeIcon
                className="tooltip-target"
                style={{ color: "white", fontSize: "16px" }}
              />
            </div>
          </div>
        ) : null}
      </Modal>
      <Modal
        width={"60%"}
        style={{ backgroundColor: "rgba(0, 0, 0, 0)" }}
        open={notificationEmailModalIsOpen}
        onCancel={() => {
          setNotificationEmailModalIsOpen(false);
          setNotificationEmailField("");
        }}
        footer={null}
      >
        <div
          style={{
            color: "rgba(0,0,0,0.4)",
            fontSize: "10px",
            fontFamily: "Manrope, sans-serif",
            fontWeight: "500",
          }}
        >
          <div
            style={{
              color: "#142C44CC",
              fontSize: "18px",
              fontFamily: "Manrope, sans-serif",
              fontWeight: "800",
            }}
          >
            User Notification Email Change
          </div>
          <div
            style={{
              color: "#142C44CC",
              fontSize: "13px",
              fontFamily: "Manrope, sans-serif",
              fontWeight: "600",
              marginTop: "14px",
              marginBottom: "8px",
            }}
          >
            Current notification email:{" "}
            {activeUser?.notification_email ? (
              activeUser.notification_email
            ) : (
              <span style={{ color: "rgba(0,0,0,0.35)" }}>Not set</span>
            )}
          </div>
          <div>
            <input
              value={notificationEmailField}
              onChange={(e) => setNotificationEmailField(e.target.value)}
              type="email"
              style={{
                borderRadius: "6px",
                border: "1px solid lightgrey",
                padding: "5px 12px",
                fontSize: "14px",
                width: "80%",
              }}
              placeholder="Input user notifiable email here"
            />
          </div>
          <div style={{ display: "flex", marginTop: "20px" }}>
            <div
              className="mui_button"
              style={{
                borderRadius: "20px",
                fontSize: "14px",
                fontWeight: "700",
                fontFamily: "Poppins, sans-serif",
                padding: "8px",
                background: "rgb(14, 90, 165)",
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
              }}
              onClick={() => {
                changeUserNotificationEmail(
                  activeUser.user_id,
                  notificationEmailField
                );
              }}
            >
              <div
                style={{
                  marginLeft: "20px",
                  marginRight: "10px",
                }}
              >
                Submit
              </div>
              <div
                style={{
                  width: "25px",
                  height: "25px",
                  borderRadius: "50%",
                  background: "white",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <NavigateNextIcon
                  style={{
                    color: "rgb(14, 90, 165)",
                    fontSize: "24px",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        width={"60%"}
        style={{ backgroundColor: "rgba(0, 0, 0, 0)" }}
        open={dataSingpassModal}
        onCancel={() => {
          setDataSingpassModal(false);
          setSingpassData(null);
          setMyinfoData(null);
          setOpenDataIndex(null);
          setKeyman("");
        }}
        footer={null}
      >
        {singpassData || myinfoData ? (
          <ProfileViewer
            keyman={keyman}
            isMobile={isMobile}
            viewingUser={viewingUser}
            setViewingUser={(data) => {
              setViewingUser(data);
            }}
            singpassData={singpassData}
            myinfoData={myinfoData}
            personalOnly={Boolean(myinfoData) && !Boolean(singpassData)}
            liveUserData={liveUserData}
            otherAuthoriserDetails={otherAuthoriserDetails}
            setLiveUserData={(data) => {
              setLiveUserData(data);
            }}
            setViewingTab={(data) => {
              setViewingTab(data);
            }}
            viewingTab={viewingTab}
            badgeVerified={badgeVerified}
            availableTab={availableTab}
            allCBSData={allCBSData}
            combinedSingpassData={combinedSingpassData}
            getShareholderAddress={(data) => {
              getShareholderAddress(data);
            }}
            backupContact={backupContact}
          />
        ) : (
          <div></div>
        )}
      </Modal>
      <Modal
        style={{
          backgroundColor: "rgba(0, 0, 0, 0)",
        }}
        width={"600px"}
        open={accountManagerModalIsOpen}
        onCancel={() => {
          setAccountManagerModalIsOpen(false);
          setAccountManagerDetails({
            profile: "",
            name: "",
            ph: "",
            email: "",
          });
        }}
        footer={null}
      >
        <div
          style={{
            color: "rgba(0,0,0,0.4)",
            fontSize: "10px",
            fontFamily: "Manrope, sans-serif",
            fontWeight: "500",
          }}
        >
          <div
            style={{
              color: "#142C44CC",
              fontSize: "18px",
              fontFamily: "Manrope, sans-serif",
              fontWeight: "800",
            }}
          >
            Account Manager details
          </div>
          <div style={{ marginTop: "15px" }}>
            <div>Account Manager Profile Photo</div>
            {accountManagerDetails.profile ? (
              <img
                style={{
                  height: "150px",
                  width: "150px",
                  borderRadius: "50%",
                  overflow: "hidden",
                  objectFit: "cover",
                  marginTop: "15px",
                }}
                src={accountManagerDetails.profile}
              />
            ) : null}
            <input
              onChange={(e) => {
                UniversaleUploadFile(e.target.files[0]);
              }}
              type="file"
              style={{
                width: "400px",
                borderRadius: 6,
                padding: "2px 10px",
                fontSize: 13,
                outline: "none",
                border: "1px solid lightgrey",
              }}
            />
            <div>Account Manager Name</div>

            <input
              value={accountManagerDetails.name}
              onChange={(e) => {
                setAccountManagerDetails({
                  ...accountManagerDetails,
                  name: e.target.value,
                });
              }}
              style={{
                width: "400px",
                borderRadius: 6,
                padding: "2px 10px",
                fontSize: 13,
                outline: "none",
                border: "1px solid lightgrey",
              }}
            />
          </div>
          <div style={{ marginTop: "7px" }}>
            <div>Account Manager Phone Number</div>
            <input
              value={accountManagerDetails.ph}
              onChange={(e) => {
                setAccountManagerDetails({
                  ...accountManagerDetails,
                  ph: e.target.value,
                });
              }}
              style={{
                width: "400px",
                borderRadius: 6,
                padding: "2px 10px",
                fontSize: 13,
                outline: "none",
                border: "1px solid lightgrey",
              }}
            />
          </div>
          <div style={{ marginTop: "7px" }}>
            <div>Account Manager Email</div>
            <input
              value={accountManagerDetails.email}
              onChange={(e) => {
                setAccountManagerDetails({
                  ...accountManagerDetails,
                  email: e.target.value,
                });
              }}
              style={{
                width: "400px",
                borderRadius: 6,
                padding: "2px 10px",
                fontSize: 13,
                outline: "none",
                border: "1px solid lightgrey",
              }}
            />
          </div>
          <div style={{ display: "flex" }}>
            <button
              onClick={(e) => {
                e.preventDefault();
                const dataTosend = {
                  user_id: activeUser.user_id,
                  account_manager: JSON.stringify(accountManagerDetails),
                };

                if (localStorage.getItem("prevAccountManager")) {
                  const prevAccountManager =
                    JSON.parse(localStorage.getItem("prevAccountManager")) ||
                    [];

                  // Check if the name already exists
                  const existingManagerIndex = prevAccountManager.findIndex(
                    (manager) => manager.name === accountManagerDetails.name
                  );

                  if (existingManagerIndex !== -1) {
                    // Update the existing manager
                    prevAccountManager[existingManagerIndex] =
                      accountManagerDetails;
                  } else {
                    // Add the new manager
                    prevAccountManager.push(accountManagerDetails);
                  }

                  localStorage.setItem(
                    "prevAccountManager",
                    JSON.stringify(prevAccountManager)
                  );
                  console.log(prevAccountManager);
                } else {
                  const dataTosave = [accountManagerDetails];
                  localStorage.setItem(
                    "prevAccountManager",
                    JSON.stringify(dataTosave)
                  );
                }

                setAccountManager(dataTosend);
              }}
              className="all_button"
              style={{
                background: "#1557a9",
                color: "white",
                border: "none",
                borderRadius: "50px",
                padding: "6px 25px",
                fontSize: "12px",
                margin: "10px 0px 0px 0px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              Update
            </button>
          </div>
          {localStorage.getItem("prevAccountManager") ? (
            <div>
              <hr
                style={{
                  width: "80%",
                  height: "1px",
                  background: "rgb(50,50,50)",
                }}
              />
              <div>
                <div
                  style={{
                    color: "#142C44CC",
                    fontSize: "18px",
                    fontFamily: "Manrope, sans-serif",
                    fontWeight: "800",
                  }}
                >
                  Select from previous managers
                </div>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    marginTop: "10px",
                    gap: "5px",
                  }}
                >
                  {JSON.parse(localStorage.getItem("prevAccountManager")).map(
                    (prevMan, index) => (
                      <div
                        className="mui_button"
                        style={{
                          padding: "5px 25px",
                          color: "grey",
                          border: "1px solid grey",
                          borderRadius: "8px",
                        }}
                        key={index}
                        onClick={() => {
                          const dataTosend = {
                            user_id: activeUser.user_id,
                            account_manager: JSON.stringify(prevMan),
                          };
                          setAccountManager(dataTosend);
                        }}
                      >
                        {prevMan.name}
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </Modal>
      <Modal
        style={{
          backgroundColor: "rgba(0, 0, 0, 0)",
        }}
        width={"600px"}
        open={otpModalIsOpen}
        onCancel={() => setOtpModalIsOpen(false)}
        footer={null}
      >
        <div>
          <div>Please type the 4 digit otp sent to Roy's email.</div>
          <div>
            <input
              value={otpPin}
              onChange={(e) => {
                setOtpPin(e.target.value);
              }}
              type="password"
              style={{
                width: "400px",
                borderRadius: 10,
                padding: "10px 20px",
                fontSize: 13,
              }}
            />
          </div>
          <div style={{ display: "flex" }}>
            <div
              onClick={() => {
                validatePassword();
              }}
              style={{
                marginTop: 20,
                background: "#196cb0",
                color: "white",
                border: "2px solid #196cb0",
                padding: "5px 35px",
                borderRadius: "20px",
                cursor: "pointer",
              }}
            >
              Confirm
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        style={{
          backgroundColor: "rgba(0, 0, 0, 0)",
        }}
        width={"600px"}
        open={modal4}
        onCancel={() => setModal4(false)}
        footer={null}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div
            style={{
              color: "#142C44CC",
              fontSize: "18px",
              fontFamily: "Manrope, sans-serif",
              fontWeight: "800",
            }}
          >
            Password Reset
          </div>
        </div>

        <hr style={{ width: "95%" }} />
        <div>
          <div>User's new password</div>
          <div>
            <input
              value={resetPassword}
              onChange={(e) => {
                setResetPassword(e.target.value);
              }}
              type="password"
              style={{
                width: "400px",
                borderRadius: 10,
                padding: "10px 20px",
                fontSize: 13,
              }}
            />
          </div>
          <div style={{ display: "flex" }}>
            <div
              onClick={() => {
                if (resetPassword === "") {
                  message.error("Password is empty");
                } else if (resetPassword.length < 8) {
                  message.error("Minimum 8 characters required for password.");
                } else {
                  console.log(activeUser.email);
                  adminResetPassword(activeUser.email);
                }
              }}
              style={{
                marginTop: 20,
                background: "#196cb0",
                color: "white",
                border: "2px solid #196cb0",
                padding: "5px 35px",
                borderRadius: "20px",
                cursor: "pointer",
              }}
            >
              Reset Password
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        style={{
          backgroundColor: "rgba(0, 0, 0, 0)",
        }}
        width={"600px"}
        open={modal5}
        onCancel={() => setModal5(false)}
        footer={null}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div
            style={{
              color: "#142C44CC",
              fontSize: "18px",
              fontFamily: "Manrope, sans-serif",
              fontWeight: "800",
            }}
          >
            Inject CBS Report
          </div>
        </div>

        <hr style={{ width: "95%" }} />
        <div>
          <div>Upload CBS report</div>
          <div>
            <input
              onChange={(e) => {
                extractText(e.target.files[0]);
                setCreditReportFile(e.target.files[0]);
              }}
              style={{
                outline: "none",
                border: "1px solid lightgrey",
                borderRadius: "8px",
                fontSize: "12px",
                padding: "5px 10px",
                width: "50%",
              }}
              type="file"
            />
          </div>
          <div style={{ display: "flex" }}>
            <div
              onClick={() => {
                setIsLoadingScreen(true);
                uploadCBSReport(creditReportFile);
              }}
              style={{
                marginTop: 20,
                background: "#196cb0",
                color: "white",
                border: "2px solid #196cb0",
                padding: "5px 35px",
                borderRadius: "20px",
                cursor: "pointer",
              }}
            >
              Inject
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        style={{
          backgroundColor: "rgba(0, 0, 0, 0)",
        }}
        width={"90vw"}
        open={modal1}
        onCancel={() => setModal1(false)}
        footer={null}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div
            style={{
              color: "#142C44CC",
              fontSize: "18px",
              fontFamily: "Manrope, sans-serif",
              fontWeight: "800",
            }}
          >
            User Details
          </div>
          <div>
            <label
              onClick={() => {
                const sanitizedData = getSanitizedUserInfo(activeUser);
                exportToExcel(sanitizedData);
              }}
              className="all_button"
              style={{
                background: "#1557a9",
                color: "white",
                width: "100%",
                border: "none",
                borderRadius: "50px",
                padding: "6px 30px",
                fontSize: "12px",
                margin: "0px 0px 0px -20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              Export
            </label>
          </div>
        </div>

        <hr style={{ width: "95%" }} />
        <div
          style={{
            display: "flex",
            fontSize: "11px",
            color: "rgba(0,0,0,0.5)",
            flexWrap: "wrap",
            gap: "1%",
          }}
        >
          {renderUserInfo(flattenObject(activeUser))}
        </div>
      </Modal>
      <Modal
        width="50%"
        style={{
          backgroundColor: "rgba(0, 0, 0, 0)",
        }}
        open={modal2}
        onCancel={() => setModal2(false)}
        footer={null}
      >
        <div
          style={{
            color: "#142C44CC",
            fontSize: "18px",
            fontFamily: "Manrope, sans-serif",
            fontWeight: "800",
          }}
        >
          Loan Details
        </div>
        <hr style={{ width: "95%" }} />
        <div
          style={{
            display: "flex",
            fontSize: "11px",
            color: "rgba(0,0,0,0.5)",
            flexWrap: "wrap",
            gap: "20px",
          }}
        >
          {renderLoanAcceptedInfo(selectedLoan)}
        </div>
        <hr style={{ width: "95%" }} />
        <div style={{ width: "100%" }}>
          <Collapse defaultActiveKey={["0"]} ghost>
            <Panel
              header="View your Repayment Schedule"
              key="1"
              // onClick={(event) =>
              //   handleViewRepaymentSchedule(
              //     selectedLoan,
              //     event
              //   )
              // }
            >
              <TableRepaymentUserDatabase
                dataRepaymentSchedule={
                  selectedLoan ? selectedLoan.repaymentSchedule : []
                }
                setDataRepaymentSchedule={setDataRepaymentSchedule}
              />
            </Panel>
          </Collapse>
        </div>
      </Modal>
      <Modal
        width="50%"
        style={{
          backgroundColor: "rgba(0, 0, 0, 0)",
        }}
        open={modal3}
        onCancel={() => setModal3(false)}
        footer={null}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "90%",
          }}
        >
          <div
            style={{
              color: "#142C44CC",
              fontSize: "18px",
              fontFamily: "Manrope, sans-serif",
              fontWeight: "800",
            }}
          >
            Loan Details
          </div>
          <div
            style={{
              display: "flex",
              width: "70%",
              justifyContent: "flex-end",
              gap: "10px",
            }}
          >
            <div style={{ display: "flex" }}>
              <div
                className="mui_button"
                style={{
                  width: "100%",
                  border: "none",
                  borderRadius: "50px",
                  padding: "10px 35px",
                  fontSize: "12px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "#ffffff",
                  background:
                    "linear-gradient(90deg, #206be3 0%, #d413c7 100%)",
                  outline: "1px solid lightgrey",
                  gap: "8px",
                }}
                onClick={() => {
                  console.log(selectedLoan2);
                  setConciergeCreatingLoanData({
                    ...conciergeCreatingLoanData,
                    loan_id: selectedLoan2.loan_id,
                    borrower_id: selectedLoan2.user_id,
                    amount: selectedLoan2.request_amount,
                    period: selectedLoan2.request_period,
                    principal: selectedLoan2.request_principal,
                    monthly_installment:
                      selectedLoan2.request_monthly_installment,
                    revenue:
                      selectedLoan2.request_principal -
                      selectedLoan2.request_amount,
                    interest_rate: selectedLoan2.request_interest_rate,
                    processing_fee: selectedLoan2.admin_fee,
                    input_interest_rate:
                      selectedLoan2.request_interest_rate * 100,
                    input_processing_fee: selectedLoan2.admin_fee * 100,
                  });
                  setIsConciergeModalOpen(true);
                }}
              >
                Create Concierge Loan
                <AutoAwesomeIcon
                  className="tooltip-target"
                  style={{ color: "white", fontSize: "16px" }}
                />
              </div>
            </div>
            {selectedLoan2 && !selectedLoan2.concierge ? (
              <div style={{ display: "flex" }}>
                <div
                  className="mui_button"
                  style={{
                    width: "100%",
                    border: "none",
                    borderRadius: "50px",
                    padding: "10px 35px",
                    fontSize: "12px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "#ffffff",
                    background:
                      "linear-gradient(90deg, #206be3 0%, #d413c7 100%)",
                    outline: "1px solid lightgrey",
                    gap: "8px",
                  }}
                  onClick={() => {
                    markAsConcierge(
                      !selectedLoan2.concierge,
                      selectedLoan2.loan_id
                    );
                  }}
                >
                  Mark as Concierge
                  <AutoAwesomeIcon
                    className="tooltip-target"
                    style={{ color: "white", fontSize: "16px" }}
                  />
                </div>
              </div>
            ) : (
              <div style={{ display: "flex" }}>
                <div
                  className="mui_button"
                  style={{
                    width: "100%",
                    border: "none",
                    borderRadius: "50px",
                    padding: "10px 35px",
                    fontSize: "12px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "#d413c7",
                    border: "2px solid #d413c7",
                    outline: "1px solid lightgrey",
                    gap: "8px",
                    fontWeight: 700,
                  }}
                  onClick={() => {
                    markAsConcierge(
                      !selectedLoan2.concierge,
                      selectedLoan2.loan_id
                    );
                  }}
                >
                  Disable Concierge
                  <AutoAwesomeIcon
                    className="tooltip-target"
                    style={{ color: "#d413c7", fontSize: "16px" }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
        <hr style={{ width: "95%" }} />
        <div
          style={{
            display: "flex",
            fontSize: "11px",
            color: "rgba(0,0,0,0.5)",
            flexWrap: "wrap",
            gap: "20px",
          }}
        >
          {renderLoanInfo(selectedLoan2)}
        </div>
      </Modal>
      <div
        style={{
          width: "75%",
          height: "100%",
          padding: "4px 0px 20px 20px",
        }}
      >
        <div
          style={{
            height: "100%",
            borderRadius: "10px",
            background:
              "transparent linear-gradient(180deg, #FFFFFFB3 0%, #FFFFFF00 100%) 0% 0% no-repeat padding-box",
            padding: "15px",
          }}
        >
          <div
            style={{
              color: "#142C44CC",
              fontSize: "18px",
              fontFamily: "Manrope, sans-serif",
              fontWeight: "800",
            }}
          >
            User Database
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "15px",
            }}
          >
            <div style={{ display: "flex" }}>
              {" "}
              {/* New div to group Borrower and Lender */}
              <div
                onClick={() => {
                  setActiveTab("Borrower");
                  setLenderProfileData(null);
                  setActiveUser(dataBorrower[0]);
                  setActivePageb(1);
                }}
                style={{
                  background:
                    activeTab === "Borrower"
                      ? "rgba(255,255,255,0.7)"
                      : "rgba(0,0,0,0.1)",
                  borderRadius: "10px 10px 0px 0px",
                  padding: "5px 25px",
                  color: "#142c44cc",
                  fontFamily: "Manrope, sans-serif",
                  fontWeight: "800",
                  fontSize: "13px",
                  cursor: "pointer",
                }}
              >
                Borrower
              </div>
              <div
                onClick={() => {
                  setActiveTab("Lender");
                  setLenderProfileData(null);
                  setActiveUser(dataLender[0]);
                  setActiveUser2(dataBorrower[0]);
                  setActivePagel(1);
                }}
                style={{
                  background:
                    activeTab === "Lender"
                      ? "rgba(255,255,255,0.7)"
                      : "rgba(0,0,0,0.1)",
                  borderRadius: "10px 10px 0px 0px",
                  padding: "5px 25px",
                  color: "#142c44cc",
                  fontFamily: "Manrope, sans-serif",
                  fontWeight: "800",
                  fontSize: "13px",
                  cursor: "pointer",
                }}
              >
                Lender
              </div>
            </div>

            {/* <div
              style={{
                background: "rgba(0,0,0,0.1)",
                borderRadius: "10px 10px 0px 0px",
                padding: "5px 25px",
                color: "#142c44cc",
                fontFamily: "Manrope, sans-serif",
                fontWeight: "800",
                fontSize: "13px",
                cursor: "pointer",
              }}
            >
              <label
                onClick={() => {
                  exportToEmailSubscribed(subscribedEmail);
                }}
                className="all_button"
                style={{
                  background: "#1557a9",
                  color: "white",
                  width: "100%",
                  border: "none",
                  borderRadius: "50px",
                  padding: "3px 15px",
                  fontSize: "10px",
                  margin: "0px 0px 0px 0px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                Email Subscribed
              </label>
            </div> */}
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "10px",
              marginTop: "10px",
              marginBottom: "8px",
              color: "#142c44cc",
              fontFamily: "Manrope, sans-serif",
            }}
          >
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "8px",
                alignItems: "center",
              }}
            >
              {userFilterOptions.map((option) => {
                const isSelected = selectedUserFilter === option.value;

                return (
                  <button
                    key={option.value}
                    type="button"
                    aria-pressed={isSelected}
                    onClick={() => {
                      if (activeTab === "Borrower") {
                        setBorrowerDataFilter(option.value);
                        setActivePageb(1);
                      } else {
                        setLenderProductFilter(option.value);
                        setActivePagel(1);
                      }
                    }}
                    className="all_button"
                    style={{
                      padding: "7px 14px",
                      border: isSelected
                        ? "1px solid #1557a9"
                        : "1px solid rgba(0,0,0,0.2)",
                      color: isSelected ? "white" : "rgba(20,44,68,0.75)",
                      background: isSelected ? "#1557a9" : "white",
                      minHeight: "30px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "10px",
                      cursor: "pointer",
                      fontSize: "11px",
                      fontWeight: 800,
                      gap: "7px",
                    }}
                  >
                    <span>{option.label}</span>
                    <span
                      style={{
                        padding: "1px 7px",
                        borderRadius: "20px",
                        background: isSelected
                          ? "rgba(255,255,255,0.2)"
                          : "rgba(21,87,169,0.08)",
                        color: isSelected ? "white" : "#1557a9",
                      }}
                    >
                      {userFilterCounts[option.value] || 0}
                    </span>
                  </button>
                );
              })}
            </div>
            <div
              style={{
                fontSize: "12px",
                fontWeight: 800,
                color: "rgba(20,44,68,0.65)",
              }}
            >
              Total:{" "}
              {activeTab === "Borrower" ? borrowerTotalCount : lenderTotalCount}
            </div>
          </div>

          <div
            style={{
              background: "rgba(255,255,255,0.7)",
              width: "100%",
              padding: "10px",
              height: "75vh",
              overflowY: "auto",
              borderRadius:
                activeTab === "Borrower" ? "0px 10px 10px 10px" : "10px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                color: "grey",
                // borderTop: "1px solid lightgrey",
                // borderBottom: "1px solid lightgrey",
                width: "100%",
                fontFamily: "Manrope, sans-serif",
                fontWeight: "800",
                fontSize: "11px",
                padding: "5px 0px",
              }}
            >
              <div style={{ width: activeTab === "Lender" ? "12%" : "15%", paddingLeft: "10px" }}>User ID</div>
              <div style={{ width: activeTab === "Lender" ? "18%" : "20%" }}>User Name</div>
              {activeTab === "Lender" ? (
                <div style={{ width: "22%" }}>Allowed Products</div>
              ) : null}
              {activeTab === "Borrower" ? (
                <div style={{ width: "8%" }}>Data</div>
              ) : null}
              <div style={{ width: activeTab === "Lender" ? "12%" : "15%" }}>Phone Number</div>
              <div style={{ width: activeTab === "Lender" ? "22%" : "30%" }}>Email</div>
              <div style={{ width: activeTab === "Lender" ? "14%" : "17%" }}>Registered</div>
              {activeTab === "Borrower" ? (
                <div style={{ width: "10%" }}>BTI Rating</div>
              ) : null}
              {activeTab === "Borrower" ? (
                <div style={{ width: "10%" }}>Employee.ID</div>
              ) : null}
              {activeTab === "Borrower" ? (
                <div style={{ width: "10%" }}>R.M</div>
              ) : null}
              {activeTab === "Borrower" ? (
                <div
                  style={{
                    width: "150px",
                  }}
                >
                  <label
                    onClick={() => {
                      const allUserInfo =
                        activeTab === "Borrower"
                          ? getBorrowerInfo(dataAll)
                          : getLenderInfo(dataAll);
                      exportToExcelAllInfo(allUserInfo, activeTab);
                    }}
                    className="all_button"
                    style={{
                      padding: "7px 20px",
                      border: "1px solid #1557a9",
                      color: "#1557a9",
                      height: "30px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "10px",
                      cursor: "pointer",
                      fontWeight: 600,
                    }}
                  >
                    Export All
                  </label>
                </div>
              ) : (
                <div style={{ width: "9%" }}>
                  <label
                    onClick={() => {
                      const allUserInfo =
                        activeTab === "Lender"
                          ? getLenderInfo(dataAll)
                          : getBorrowerInfo(dataAll);
                      exportToExcelAllInfo(allUserInfo, activeTab);
                    }}
                    className="all_button"
                    style={{
                      padding: "7px 20px",
                      border: "1px solid #1557a9",
                      color: "#1557a9",
                      height: "30px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "10px",
                      cursor: "pointer",
                      fontWeight: 600,
                    }}
                  >
                    Export All
                  </label>
                </div>
              )}
            </div>
            {/* The API filters before pagination, including normalized phone matches. */}
            {activeTab === "Borrower"
              ? dataBorrower
                  .map((user, index) => (
                    <div
                      onClick={() => {
                        setActiveUser(user);
                        console.log(user.user_id)
                        fetchWelcomeWizardResponse(user.user_id)
                      }}
                      className="db_user_row"
                      key={index}
                      style={{
                        background:
                          index % 2 ? "white" : "rgba(17, 92, 166, 0.05)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        color: "#142C44CC",
                        width: "100%",
                        fontFamily: "Manrope, sans-serif",
                        fontWeight: "800",
                        fontSize: "11px",
                        padding: "5px 0px",
                        height: "40px",
                      }}
                    >
                      <div
                        style={{
                          width: "15%",
                          paddingLeft: "10px",
                          display: "flex",
                          gap: "10px",
                        }}
                      >
                        <div>{index + 1}.</div>
                        <div>{user.user_id}</div>
                      </div>
                      <div style={{ width: "19%" }}>
                        {getBorrowerDisplayName(user)}
                      </div>
                      <div
                        style={{
                          width: "8%",
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        {hasSingpassPayload(user) ? (
                          <Tooltip title="Singpass data available">
                            <BusinessIcon
                              style={{
                                fontSize: "16px",
                                color: "#1557a9",
                              }}
                            />
                          </Tooltip>
                        ) : null}
                        {hasMyInfoPayload(user) ? (
                          <Tooltip title="MyInfo data available">
                            <PersonIcon
                              style={{
                                fontSize: "16px",
                                color: "#2e7d32",
                              }}
                            />
                          </Tooltip>
                        ) : null}
                        {!hasSingpassPayload(user) && !hasMyInfoPayload(user) ? (
                          <span>-</span>
                        ) : null}
                      </div>
                      <div style={{ width: "15%" }}>
                        {user.active_mobile_no
                          ? user.active_mobile_no
                          : user.mobile_no
                          ? user.mobile_no
                          : "None inserted"}
                      </div>
                      <div style={{ width: "29%" }}>
                        {user.active_email
                          ? user.active_email
                          : user.email
                          ? user.email
                          : "None inserted"}
                      </div>
                      <div style={{ width: "15%" }}>
                        {addressFormatter(user.created_at)}
                      </div>
                      <div style={{ width: "10%" }}>
                        {(() => {
                          try {
                            const credit = JSON.parse(
                              user.credit_report_data || "{}"
                            );
                            const noas =
                              getPersonData(user.singpass_data)?.noahistory?.noas ||
                              [];

                            // Step 1: Find the latest NOA based on year
                            const latestNoa = noas
                              .filter(
                                (n) =>
                                  !isNaN(Number(n?.yearofassessment?.value))
                              )
                              .sort(
                                (a, b) =>
                                  Number(b.yearofassessment.value) -
                                  Number(a.yearofassessment.value)
                              )[0];

                            // Step 2: Check that all required values exist
                            const hasValidCredit =
                              credit?.RiskGrade != null &&
                              credit?.UnsecuredCreditLimit != null &&
                              credit?.UnsecuredCreditUtilized != null;

                            const hasValidNoaAmount =
                              parseFloat(latestNoa?.amount?.value) > 0;

                            if (
                              hasValidCredit &&
                              latestNoa &&
                              hasValidNoaAmount
                            ) {
                              const utilizationRatio =
                                parseFloat(credit.UnsecuredCreditUtilized) /
                                (parseFloat(latestNoa.amount.value) / 12);

                              return `${
                                credit.RiskGrade
                              } ${utilizationRatio.toFixed(2)}`;
                            } else {
                              return "N/A";
                            }
                          } catch (err) {
                            return "N/A";
                          }
                        })()}
                      </div>
                      <div style={{ width: "10%" }}>
                        {user.employee_id
                          ? getEmployeeName(user.employee_id)
                          : "Web"}
                      </div>
                      <div style={{ width: "10%" }}>
                        {user.account_manager
                          ? JSON.parse(user.account_manager)?.name
                          : "None"}
                      </div>
                      {user.credit_report ? (
                        // Render the button if credit_report is not null/undefined
                        <button
                          className="all_button"
                          onClick={(event) =>
                            handleDownloadCreditReport(user.user_id, event)
                          }
                          style={{
                            padding: "7px 20px",
                            background: "white",
                            border: "1px solid #1557a9",
                            color: "#1557a9",
                            height: "30px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "10px",
                            cursor: "pointer",
                            fontWeight: 600,
                            width: "150px",
                          }}
                        >
                          Credit Report
                        </button>
                      ) : (
                        // Render an invisible placeholder if credit_report is null/undefined
                        <div
                          style={{
                            width: "150px",
                            display: "flex",
                            padding: "3px 5px",
                          }}
                        />
                      )}
                    </div>
                  ))
              : dataLender
                  .map((user, index) => (
                    <div
                      onClick={() => {
                        console.log(user);
                        setLenderProfileData(null);
                        setActiveUser(user);
                      }}
                      className="db_user_row"
                      key={index}
                      style={{
                        background:
                          index % 2 ? "white" : "rgba(17, 92, 166, 0.05)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        color: "#142C44CC",
                        width: "100%",
                        fontFamily: "Manrope, sans-serif",
                        fontWeight: "800",
                        fontSize: "11px",
                        padding: "5px 0px",
                        minHeight: "40px",
                        overflowWrap: "anywhere",
                      }}
                    >
                      <div
                        style={{
                          width: "12%",
                          paddingLeft: "10px",
                          display: "flex",
                          gap: "10px",
                        }}
                      >
                        <div>{index + 1}.</div>
                        <div>{user.user_id}</div>
                      </div>
                      <div style={{ width: "18%" }}>
                        {user.principal_name}
                      </div>
                      <div style={{ width: "22%", paddingRight: 8, boxSizing: "border-box", flexShrink: 0 }}>
                        {(() => {
                          const products = [...new Set(normalizeAllowedProducts(user.lender_allowed_products))]
                            .filter((product) => typeof product === "string" && product.trim());
                          return products.length ? (
                            <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                              {products.map((product) => (
                                <Tag
                                  key={product}
                                  color={lenderProductColors[product]}
                                  style={{ margin: 0, fontSize: 10, lineHeight: "18px" }}
                                >
                                  {lenderProductOptions.find((option) => option.value === product)?.label || product}
                                </Tag>
                              ))}
                            </div>
                          ) : <Tag style={{ margin: 0, fontSize: 10 }}>None</Tag>;
                        })()}
                      </div>
                      <div style={{ width: "12%" }}>
                        {user.active_mobile_no
                          ? user.active_mobile_no
                          : user.mobile_no
                          ? user.mobile_no
                          : "None inserted"}
                      </div>
                      <div style={{ width: "22%" }}>
                        {user.active_email
                          ? user.active_email
                          : user.email
                          ? user.email
                          : "None inserted"}
                      </div>
                      <div style={{ width: "14%" }}>
                        {addressFormatter(user.created_at)}
                      </div>
                    </div>
                  ))}
          </div>
          <div>
            <div
              style={{
                marginTop: "10px",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "8px",
              }}
            >
              <button
                onClick={() => {
                  if (activeTab === "Borrower" && activePageb > 1) {
                    setActivePageb(activePageb - 1);
                  }
                  if (activeTab === "Lender" && activePagel > 1) {
                    setActivePagel(activePagel - 1);
                  }
                }}
                disabled={
                  activeTab === "Borrower" ? activePageb === 1 : activePagel === 1
                }
                style={{
                  padding: "6px 10px",
                  borderRadius: "4px",
                  background: "#f7f7f7",
                  color: "#333",
                  border: "1px solid lightgrey",
                  cursor: "pointer",
                  opacity:
                    activeTab === "Borrower"
                      ? activePageb === 1
                        ? 0.5
                        : 1
                      : activePagel === 1
                        ? 0.5
                        : 1,
                }}
              >
                Prev
              </button>
              {paginationItems.map((item, index) => {
                if (typeof item !== "number") {
                  return (
                    <span
                      key={`${item}-${index}`}
                      style={{
                        padding: "6px 4px",
                        color: "#888",
                        minWidth: "20px",
                        textAlign: "center",
                      }}
                    >
                      ...
                    </span>
                  );
                }

                const isActive =
                  activeTab === "Borrower"
                    ? activePageb === item
                    : activePagel === item;

                return (
                  <button
                    key={item}
                    onClick={() => {
                      if (activeTab === "Borrower") {
                        setActivePageb(item);
                      } else {
                        setActivePagel(item);
                      }
                    }}
                    style={{
                      padding: "6px 10px",
                      minWidth: "38px",
                      borderRadius: "4px",
                      background: isActive ? "#058cfa" : "#f0f0f0",
                      color: isActive ? "white" : "black",
                      border: "1px solid lightgrey",
                      cursor: "pointer",
                    }}
                  >
                    {item}
                  </button>
                );
              })}
              <button
                onClick={() => {
                  if (activeTab === "Borrower" && activePageb < pageCountb) {
                    setActivePageb(activePageb + 1);
                  }
                  if (activeTab === "Lender" && activePagel < pageCountl) {
                    setActivePagel(activePagel + 1);
                  }
                }}
                disabled={
                  activeTab === "Borrower"
                    ? activePageb === pageCountb
                    : activePagel === pageCountl
                }
                style={{
                  padding: "6px 10px",
                  borderRadius: "4px",
                  background: "#f7f7f7",
                  color: "#333",
                  border: "1px solid lightgrey",
                  cursor: "pointer",
                  opacity:
                    activeTab === "Borrower"
                      ? activePageb === pageCountb
                        ? 0.5
                        : 1
                      : activePagel === pageCountl
                        ? 0.5
                        : 1,
                }}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          width: "25%",
          height: "100%",
          padding: "4px 20px 20px 0px",
        }}
      >
        <div
          style={{
            height: "100%",
            borderRadius: "10px",
            background:
              "transparent linear-gradient(0deg, #FFFFFFB3 0%, #FFFFFF00 100%) 0% 0% no-repeat padding-box",
            padding: "15px",
          }}
        >
          <div
            style={{
              color: "#142C44CC",
              fontSize: "18px",
              fontFamily: "Manrope, sans-serif",
              fontWeight: "800",
            }}
          >
            User Details
          </div>
          {activeUser ? (
            <div
              style={{
                background: "rgba(255,255,255,0.7)",
                height: "78vh",
                width: "100%",
                borderRadius: "10px",
                marginTop: "15px",
                color: "#142C44CC",
                fontFamily: "Manrope, sans-serif",
                fontWeight: "800",
                fontSize: "11px",
                padding: "10px",
                overflowY: "scroll",
                position: "relative",
                overflow: "visible",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  background: "white",
                  borderRadius: "10px",
                  padding: "20px",
                  top: 0,
                  right: lenderProfileData ? "calc(100% + 20px)" : "100%",
                  opacity: lenderProfileData ? 1 : 0,
                  width: "400px",
                  boxShadow: "0px 0px 10px rgba(0,0,0,0.05)",
                  transition:
                    "right 0.4s ease-in-out, opacity 0.4s ease-in-out, display 0s",
                  zIndex: 200,
                  display: lenderProfileData ? "block" : "none",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "15px",
                  }}
                >
                  <div>
                    <img
                      style={{
                        height: "80px",
                        width: "80px",
                        borderRadius: "50%",
                        background: "lightgrey",
                        boxShadow: "0px 0px 10px rgba(0,0,0,0.05)",
                        objectFit: "cover",
                      }}
                      src={lenderProfileData?.profile?.profile_photo}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <div
                      style={{
                        color: "rgb(14, 90, 165)",
                        fontSize: "20px",
                        fontFamily: "Manrope,sans-serif",
                        fontWeight: 800,
                        marginBottom: "5px",
                      }}
                    >
                      {lenderProfileData?.profile?.company_name}
                    </div>
                    {lenderProfileData?.profile?.additionals?.map(
                      (addi, index) => (
                        <div
                          key={index}
                          style={{ display: "flex", gap: "10px" }}
                        >
                          <div
                            style={{
                              width: "100%",
                              border: "none",
                              outline: "none",
                              color: "rgba(0,0,0,0.6)",
                              marginTop: "-5px",
                              fontSize: "12px",
                              fontWeight: "400",
                            }}
                          >
                            {addi?.text}
                          </div>
                        </div>
                      )
                    )}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                        marginLeft: "-5px",
                        marginTop: "5px",
                      }}
                    >
                      {lenderProfileData?.profile?.social?.map(
                        (soci, index) => (
                          <div
                            key={index}
                            style={{
                              padding: "5px",
                              position: "relative",
                            }}
                          >
                            <FontAwesomeIcon
                              icon={iconLibrary[soci?.icon]}
                              style={{
                                fontSize: 20,
                                color: "rgb(14, 90, 165)",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                if (soci.link !== "" && soci.link !== null) {
                                  window.location.href = soci.link;
                                }
                              }}
                            />
                          </div>
                        )
                      )}
                    </div>
                  </div>
                </div>
                <hr
                  style={{
                    width: "90%",
                    marginLeft: "5%",
                    background: "grey",
                    border: "none",
                    outline: "none",
                  }}
                />
                {lenderProfileData?.content?.map((cont, index) =>
                  cont.type === "text" ? (
                    <div
                      key={index}
                      style={{
                        position: "relative",
                        marginTop: cont.mt,
                        marginBottom: cont.mb,
                        textDecoration: cont.underline ? "underline" : "none",
                        fontWeight: cont.fontWeight === 400 ? 400 : 600,
                        fontSize: cont.fontWeight === 400 ? "12px" : "16px",
                        border: "none",
                        outline: "none",
                        color: "rgba(0,0,0,0.6)",
                        width: "100%",
                      }}
                    >
                      {cont?.text}
                    </div>
                  ) : cont?.type === "button" ? (
                    <div
                      key={index}
                      style={{
                        position: "relative",
                        display: "flex",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        if (cont.url !== "" && cont.url !== null) {
                          window.location.href = cont.url;
                        }
                      }}
                    >
                      <div
                        style={{
                          marginTop: cont.mt,
                          marginBottom: cont.mb,
                          fontWeight: 500,
                          fontSize: "14px",
                          border: "1px solid rgba(0,0,0,0.05)",
                          outline: "none",
                          color: "white",
                          background: "rgb(14, 90, 165)",
                          padding: "7px 30px",
                          borderRadius: "30px",
                        }}
                      >
                        {cont?.text}
                      </div>
                    </div>
                  ) : (
                    <div
                      key={index}
                      style={{
                        position: "relative",
                        marginTop: cont.mt,
                        marginBottom: cont.mb,
                      }}
                    >
                      <img
                        style={{
                          objectFit: "cover",
                          width: "80%",
                          height: "150px",
                          border: "none",
                          outline: "none",
                        }}
                        src={cont?.url}
                      />
                    </div>
                  )
                )}
              </div>
              <div
                style={{
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  margin: "0px",
                }}
              >
                <div
                  style={{
                    flex: 1,
                    textAlign: "left",
                    marginLeft: "0px",
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    flexDirection: "column",
                  }}
                >
                  <div>
                    <h3
                      style={{
                        fontFamily: "Manrope, sans-serif",
                        fontWeight: "600",
                        fontSize: "11px",
                        color: "rgba(0,0,0,0.4)",
                        margin: "0px",
                      }}
                    >
                      Principal Name
                    </h3>
                    <p
                      style={{
                        fontFamily: "Manrope, sans-serif",
                        fontWeight: "800",
                        fontSize: "18px",
                        textAlign: "left",
                        color: "rgba(20, 44, 68, 0.8)",
                        margin: "0px",
                      }}
                    >
                      {activeTab === "Borrower"
                        ? getBorrowerDisplayName(activeUser)
                          ? getBorrowerDisplayName(activeUser).length > 15
                            ? getBorrowerDisplayName(activeUser).slice(0, 15) +
                              "..."
                            : getBorrowerDisplayName(activeUser)
                          : null
                        : activeUser.principal_name
                        ? activeUser.principal_name.length > 15
                          ? activeUser.principal_name.slice(0, 15) + "..."
                          : activeUser.principal_name
                        : null}
                    </p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "10px",
                      alignItems: "center",
                      marginTop: "15px",
                    }}
                  >
                    {activeTab === "Borrower" &&
                    (hasSingpassPayload(activeUser) ||
                      hasMyInfoPayload(activeUser)) ? (
                      <div
                        onClick={handleBorrowerViewDetails}
                        className="all_button"
                        style={{
                          padding: "7px 20px",
                          border: "1px solid rgba(0,0,0,0.6)",
                          color: "rgba(0,0,0,0.6)",
                          height: "30px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRadius: "10px",
                          cursor: "pointer",
                        }}
                      >
                        View details
                      </div>
                    ) : activeTab === "Borrower" ? null : (
                      <div
                        onClick={() => {
                          handleGetLenderProfile(activeUser.user_id);
                        }}
                        className="all_button"
                        style={{
                          padding: "7px 20px",
                          border: "1px solid rgba(0,0,0,0.6)",
                          color: "rgba(0,0,0,0.6)",
                          height: "30px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRadius: "10px",
                          cursor: "pointer",
                        }}
                      >
                        View Profile
                      </div>
                    )}

                    <div
                      onClick={(e) => {
                        e.preventDefault();
                        const url = `/a-message?userid=${activeUser.user_id}&principelname=${activeUser.principal_name}`;
                        history.push(url);
                      }}
                      className="all_button"
                      style={{
                        padding: "7px 20px",
                        border: "1px solid rgba(0,0,0,0.6)",
                        color: "rgba(0,0,0,0.6)",
                        height: "30px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "10px",
                        cursor: "pointer",
                      }}
                    >
                      Message user
                    </div>

                    <div
                      onClick={(e) => {
                        e.preventDefault();
                        setNotificationEmailField(
                          activeUser?.notification_email || ""
                        );
                        setNotificationEmailModalIsOpen(true);
                      }}
                      className="all_button"
                      style={{
                        padding: "7px 20px",
                        border: "1px solid rgba(0,0,0,0.6)",
                        color: "rgba(0,0,0,0.6)",
                        height: "30px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "10px",
                        cursor: "pointer",
                      }}
                    >
                      Notification Email
                    </div>

                    <div
                      onClick={(e) => {
                        e.preventDefault();
                        sendTestUniversalEmail(activeUser.user_id);
                      }}
                      className="all_button"
                      style={{
                        padding: "7px 20px",
                        border: "1px solid rgba(0,0,0,0.6)",
                        color: "rgba(0,0,0,0.6)",
                        height: "30px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "10px",
                        cursor: isSendingTestUniversalEmail
                          ? "not-allowed"
                          : "pointer",
                        opacity: isSendingTestUniversalEmail ? 0.6 : 1,
                      }}
                    >
                      {isSendingTestUniversalEmail
                        ? "Sending test..."
                        : "Send test universal email"}
                    </div>

                    {activeTab === "Borrower" ? (
                      <div
                        onClick={() => {
                          setModal5(true);
                        }}
                        className="all_button"
                        style={{
                          padding: "7px 20px",
                          border: "1px solid rgba(0,0,0,0.6)",
                          color: "rgba(0,0,0,0.6)",
                          height: "30px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRadius: "10px",
                          cursor: "pointer",
                        }}
                      >
                        Inject CBS
                      </div>
                    ) : null}

                    <div
                      onClick={() => {
                        setModal4(true);
                      }}
                      className="all_button"
                      style={{
                        padding: "7px 20px",
                        border: "1px solid rgba(0,0,0,0.6)",
                        color: "rgba(0,0,0,0.6)",
                        height: "30px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "10px",
                        cursor: "pointer",
                      }}
                    >
                      Reset password
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ marginTop: "10px" }}>
                <h3
                  style={{
                    fontFamily: "Manrope, sans-serif",
                    fontWeight: "600",
                    fontSize: "11px",
                    color: "rgba(0,0,0,0.4)",
                    margin: "0px",
                  }}
                >
                  VPN Function (Only use if required)
                </h3>
                <div style={{ display: "flex", marginTop: "7px" }}>
                  <div
                    onClick={() => {
                      setVpntoaccountuserId(activeUser.user_id);
                      setOtpModalIsOpen(true);
                      createVPNPin();
                    }}
                    className="all_button"
                    style={{
                      padding: "7px 20px",
                      border: "1px solid rgba(0,0,0,0.6)",
                      color: "rgba(0,0,0,0.6)",
                      height: "30px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "10px",
                      cursor: "pointer",
                    }}
                  >
                    VPN to account
                  </div>
                </div>
              </div>

              <div style={{ marginTop: "10px" }}>
                <h3
                  style={{
                    fontFamily: "Manrope, sans-serif",
                    fontWeight: "600",
                    fontSize: "11px",
                    color: "rgba(0,0,0,0.4)",
                    margin: "0px",
                  }}
                >
                  Account Manager
                </h3>
                {activeUser.account_manager ? (
                  <div>{JSON.parse(activeUser.account_manager)?.name}</div>
                ) : (
                  <div>No Account Manager set.</div>
                )}
                <div style={{ display: "flex", marginTop: "7px" }}>
                  <div
                    onClick={() => {
                      setAccountManagerModalIsOpen(true);
                      if (activeUser.account_manager) {
                        setAccountManagerDetails(
                          JSON.parse(activeUser.account_manager)
                        );
                      }
                    }}
                    className="all_button"
                    style={{
                      padding: "7px 20px",
                      border: "1px solid rgba(0,0,0,0.6)",
                      color: "rgba(0,0,0,0.6)",
                      height: "30px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "10px",
                      cursor: "pointer",
                    }}
                  >
                    Set/Change Account Manager
                  </div>
                </div>
              </div>
              {activeTab === "Borrower" ? (
                <div style={{ marginTop: "10px" }}>
                  <h3
                    style={{
                      fontFamily: "Manrope, sans-serif",
                      fontWeight: "600",
                      fontSize: "11px",
                      color: "rgba(0,0,0,0.4)",
                      margin: "0px",
                    }}
                  >
                    Welcome Wizard Responses
                  </h3>
                  <div style={{ marginTop: "7px", fontWeight: "600" }}>
                    {renderWelcomeWizardResponse()}
                  </div>
                  <div style={{ display: "flex", marginTop: "7px" }}>
                    <div
                      onClick={() => {
                        if (!isWelcomeWizardLoading) {
                          fetchWelcomeWizardResponse();
                        }
                      }}
                      className="all_button"
                      style={{
                        padding: "7px 20px",
                        border: "1px solid rgba(0,0,0,0.6)",
                        color: "rgba(0,0,0,0.6)",
                        height: "30px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "10px",
                        cursor: isWelcomeWizardLoading
                          ? "not-allowed"
                          : "pointer",
                        opacity: isWelcomeWizardLoading ? 0.6 : 1,
                      }}
                    >
                      {isWelcomeWizardLoading ? "Loading..." : "Load responses"}
                    </div>
                  </div>
                </div>
              ) : null}
              {activeTab === "Lender" ? (
                activeUser ? (
                  <div
                    style={{
                      textAlign: "center",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "flex-start",
                      margin: "10px 0px 0px 0px",
                    }}
                  >
                    <div
                      style={{ flex: 1, textAlign: "left", marginLeft: "0px" }}
                    >
                      {" "}
                      <div>
                        {activeUser ? (
                          activeUser.subscription ? (
                            JSON.parse(activeUser.subscription).validity &&
                            new Date(
                              JSON.parse(activeUser.subscription).validity
                            ) < currentDate ? (
                              <div
                                style={{
                                  fontFamily: "Manrope, sans-serif",
                                  fontWeight: "600",
                                  fontSize: "11px",
                                  color: "red",
                                  margin: "0px",
                                }}
                              >
                                Subscription expired
                              </div>
                            ) : (
                              <div
                                style={{
                                  fontFamily: "Manrope, sans-serif",
                                  fontWeight: "600",
                                  fontSize: "11px",
                                  color: "rgba(0,0,0,0.4)",
                                  margin: "0px",
                                }}
                              >
                                Subscription
                              </div>
                            )
                          ) : null
                        ) : null}
                      </div>
                      <p
                        style={{
                          fontFamily: "Manrope, sans-serif",
                          fontWeight: "800",
                          fontSize: "18px",
                          textAlign: "left",
                          color: "rgba(20, 44, 68, 0.8)",
                          margin: "0px",
                        }}
                      >
                        <select
                          id="plan"
                          name="plan"
                          style={{
                            fontFamily: "Manrope, sans-serif",
                            fontWeight: "800",
                            fontSize: "18px",
                            textAlign: "left",
                            color: "rgba(20, 44, 68, 0.8)",
                            margin: "0px",
                            padding: "8px 20px",
                            outline: "none",
                            border: "1px solid lightgrey",
                            borderRadius: "10px",
                          }}
                          value={
                            activeUser.subscription
                              ? JSON.parse(activeUser.subscription).plan
                                ? JSON.parse(activeUser.subscription).plan
                                : ""
                              : ""
                          }
                          onChange={async (e) => {
                            let sampleSubscription = { plan: "", validity: "" };
                            if (activeUser.subscription) {
                              sampleSubscription = JSON.parse(
                                activeUser.subscription
                              );
                            }
                            sampleSubscription.plan = e.target.value;
                            try {
                              const formData = new FormData();
                              formData.append("user_id", activeUser.user_id);
                              formData.append(
                                "subscription",
                                JSON.stringify(sampleSubscription)
                              );

                              const response = await fetch(
                                "https://www.smart-lend.com/api/subcription/updateSubscription",
                                {
                                  method: "POST",
                                  headers: {
                                    Authorization:
                                      "Bearer " + Cookies.get("token"),
                                    Accept: "application/json",
                                  },
                                  body: formData,
                                }
                              );
                              const json = await response.json();
                              console.log(json);

                              const changingActiveUser = { ...activeUser };
                              changingActiveUser.subscription =
                                JSON.stringify(sampleSubscription);
                              setActiveUser(changingActiveUser);

                              const updatingUserArray = [...dataLender];
                              const lenderIndex = updatingUserArray.findIndex(
                                (lender) =>
                                  lender.user_id === activeUser.user_id
                              );
                              updatingUserArray[lenderIndex].subscription =
                                JSON.stringify(sampleSubscription);
                              setDataLender(updatingUserArray);
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                        >
                          <option value="">Select a plan</option>
                          <option value="Platinum">Platinum</option>
                          <option value="Gold">Gold</option>
                          <option value="Silver">Silver</option>
                        </select>
                      </p>
                      <p
                        style={{
                          fontFamily: "Manrope, sans-serif",
                          fontWeight: "600",
                          fontSize: "11px",
                          color: "rgba(0,0,0,0.4)",
                          margin: "0px",
                        }}
                      >
                        <input
                          type="date"
                          id="validity"
                          name="validity"
                          style={{
                            fontFamily: "Manrope, sans-serif",
                            fontWeight: "600",
                            fontSize: "11px",
                            color: "rgba(0,0,0,0.4)",
                            margin: "5px 0px 0px 0px",
                            padding: "6px 20px",
                            outline: "none",
                            border: "1px solid lightgrey",
                            borderRadius: "10px",
                          }}
                          value={
                            activeUser.subscription
                              ? JSON.parse(activeUser.subscription).validity
                                ? JSON.parse(
                                    activeUser.subscription
                                  ).validity.split(" ")[0]
                                : new Date().toISOString().split("T")[0]
                              : new Date().toISOString().split("T")[0]
                          }
                          onChange={async (e) => {
                            let sampleSubscription = { plan: "", validity: "" };
                            if (activeUser.subscription) {
                              sampleSubscription = JSON.parse(
                                activeUser.subscription
                              );
                            }
                            sampleSubscription.validity = e.target.value;
                            try {
                              const formData = new FormData();
                              formData.append("user_id", activeUser.user_id);
                              formData.append(
                                "subscription",
                                JSON.stringify(sampleSubscription)
                              );

                              const response = await fetch(
                                "https://www.smart-lend.com/api/subcription/updateSubscription",
                                {
                                  method: "POST",
                                  headers: {
                                    Authorization:
                                      "Bearer " + Cookies.get("token"),
                                    Accept: "application/json",
                                  },
                                  body: formData,
                                }
                              );
                              const json = await response.json();
                              console.log(json);

                              const changingActiveUser = { ...activeUser };
                              changingActiveUser.subscription =
                                JSON.stringify(sampleSubscription);
                              setActiveUser(changingActiveUser);

                              const updatingUserArray = [...dataLender];
                              const lenderIndex = updatingUserArray.findIndex(
                                (lender) =>
                                  lender.user_id === activeUser.user_id
                              );
                              updatingUserArray[lenderIndex].subscription =
                                JSON.stringify(sampleSubscription);
                              setDataLender(updatingUserArray);
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                        />
                      </p>
                      <div style={{ marginTop: "12px" }}>
                        <div
                          style={{
                            fontFamily: "Manrope, sans-serif",
                            fontWeight: "600",
                            fontSize: "11px",
                            color: "rgba(0,0,0,0.4)",
                            margin: "0px 0px 6px 0px",
                          }}
                        >
                          Allowed Products
                        </div>
                        <Select
                          mode="multiple"
                          placeholder="Select products"
                          style={{ width: "100%" }}
                          value={normalizeAllowedProducts(
                            activeUser?.lender_allowed_products
                          )}
                          options={lenderProductOptions}
                          onChange={async (products) => {
                            if (!activeUser) {
                              return;
                            }

                            try {
                              await updateLenderAllowedProducts(
                                activeUser.user_id,
                                products
                              );

                              const nextActiveUser = {
                                ...activeUser,
                                lender_allowed_products: products,
                              };
                              setActiveUser(nextActiveUser);

                              const updatingUserArray = [...dataLender];
                              const lenderIndex = updatingUserArray.findIndex(
                                (lender) =>
                                  lender.user_id === activeUser.user_id
                              );
                              if (lenderIndex !== -1) {
                                updatingUserArray[
                                  lenderIndex
                                ].lender_allowed_products = products;
                                setDataLender(updatingUserArray);
                              }

                              setLenderProductsRevision((revision) => revision + 1);
                              message.success("Allowed products updated");
                            } catch (error) {
                              message.error(
                                "Unable to update allowed products"
                              );
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                ) : null
              ) : null}
              {activeTab == "Borrower" ? (
                <div
                  style={{
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    margin: "10px 0px 0px 0px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      flex: 1,
                      textAlign: "left",
                      marginLeft: "0px",
                      width: "100%",
                      marginBottom: "10px",
                    }}
                  >
                    <h3
                      style={{
                        fontFamily: "Manrope, sans-serif",
                        fontWeight: "600",
                        fontSize: "11px",
                        color: "rgba(0,0,0,0.4)",
                        margin: "0px",
                      }}
                    >
                      Loan Accepted
                    </h3>
                    <>
                      {activeUser.loanAccepted.map((loan, index) => {
                        const isLate = hasLateDays(loan, 0);
                        const todayDateString = getCurrentDate();
                        const isAlmostThreeDay = hasAlmostThreeDay(
                          loan,
                          todayDateString
                        );

                        return (
                          <div
                            key={index}
                            style={{
                              background: "rgba(255,255,255,0.7)",
                              boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
                              borderRadius: "10px",
                              width: "100%",
                              marginTop: "10px",
                              display: "flex",
                              justifyContent: "space-between",
                              padding: "10px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setSelectedLoan(loan);
                              setModal2(true);
                            }}
                          >
                            <div>
                              <p
                                style={{
                                  fontFamily: "Manrope, sans-serif",
                                  fontWeight: "800",
                                  fontSize: "12px",
                                  textAlign: "left",
                                  color: "rgba(0,0,0,0.5)",
                                  margin: "0px",
                                }}
                              >
                                {loan.loan_id}
                              </p>
                              <p
                                style={{
                                  fontFamily: "Manrope, sans-serif",
                                  fontWeight: "800",
                                  fontSize: "18px",
                                  textAlign: "left",
                                  color: "rgba(20, 44, 68, 0.8)",
                                  margin: "0px",
                                }}
                              >
                                {loan.amount}
                              </p>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                flexDirection: "column",
                                alignItems: "flex-end",
                              }}
                            >
                              {/* <div
      style={{
        height: "8px",
        width: "8px",
        borderRadius: "8px",
        background:
          loan.status === "accepted" ? "green" : "yellow",
        boxShadow:
          loan.status === "accepted"
            ? "0px 0px 5px green"
            : "0px 0px 5px yellow",
      }}
    ></div> */}
                              <div
                                className={isLate ? "blink" : ""}
                                style={{
                                  height: "8px",
                                  width: "8px",
                                  borderRadius: "8px",
                                  background: isAlmostThreeDay
                                    ? "red"
                                    : loan.status === "accepted"
                                    ? "green"
                                    : "yellow",
                                  boxShadow:
                                    loan.status === "accepted"
                                      ? "0px 0px 5px green"
                                      : "0px 0px 5px yellow",
                                }}
                              ></div>

                              <p
                                style={{
                                  fontFamily: "Manrope, sans-serif",
                                  fontWeight: "800",
                                  fontSize: "12px",
                                  textAlign: "left",
                                  color: "rgba(0,0,0,0.5)",
                                  margin: "0px",
                                }}
                              >
                                {new Date(loan.created_at).toLocaleDateString(
                                  "en-US",
                                  options
                                )}
                              </p>
                            </div>
                          </div>
                        );
                      })}
                    </>
                  </div>
                  <div
                    style={{
                      flex: 1,
                      textAlign: "left",
                      marginLeft: "0px",
                      width: "100%",
                    }}
                  >
                    <h3
                      style={{
                        fontFamily: "Manrope, sans-serif",
                        fontWeight: "600",
                        fontSize: "11px",
                        color: "rgba(0,0,0,0.4)",
                        margin: "0px",
                      }}
                    >
                      Loan Requested
                    </h3>
                    {activeUser.loanRequest.map((loan, index) => (
                      <div
                        key={index}
                        style={{
                          background: loan.concierge
                            ? "linear-gradient(90deg, #206be3 0%, #d413c7 100%)"
                            : "rgba(255,255,255,0.7)",
                          boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
                          borderRadius: "10px",
                          width: "100%",
                          marginTop: "10px",
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "10px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setSelectedLoan2(loan);
                          setModal3(true);
                        }}
                      >
                        <div>
                          <p
                            style={{
                              fontFamily: "Manrope, sans-serif",
                              fontWeight: "800",
                              fontSize: "12px",
                              textAlign: "left",
                              color: loan.concierge
                                ? "white"
                                : "rgba(0,0,0,0.5)",
                              margin: "0px",
                            }}
                          >
                            {loan.loan_id}
                          </p>
                          <p
                            style={{
                              fontFamily: "Manrope, sans-serif",
                              fontWeight: "800",
                              fontSize: "18px",
                              textAlign: "left",
                              color: loan.concierge
                                ? "white"
                                : "rgba(20, 44, 68, 0.8)",
                              margin: "0px",
                            }}
                          >
                            {loan.request_amount}
                          </p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            flexDirection: "column",
                            alignItems: "flex-end",
                          }}
                        >
                          <div
                            style={{
                              height: "8px",
                              width: "8px",
                              borderRadius: "8px",
                              background:
                                loan.status === "accepted" ? "green" : "yellow",
                              boxShadow:
                                loan.status === "accepted"
                                  ? "0px 0px 5px green"
                                  : "0px 0px 5px yellow",
                            }}
                          ></div>
                          <p
                            style={{
                              fontFamily: "Manrope, sans-serif",
                              fontWeight: "800",
                              fontSize: "12px",
                              textAlign: "left",
                              color: loan.concierge
                                ? "white"
                                : "rgba(0,0,0,0.5)",
                              margin: "0px",
                            }}
                          >
                            {new Date(loan.created_at).toLocaleDateString(
                              "en-US",
                              options
                            )}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ) : activeTab == "Lender" ? (
                <div
                  style={{
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    margin: "20px 0px 0px 0px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      flex: 1,
                      textAlign: "left",
                      marginLeft: "0px",
                      width: "100%",
                      marginBottom: "10px",
                    }}
                  >
                    <h3
                      style={{
                        fontFamily: "Manrope, sans-serif",
                        fontWeight: "600",
                        fontSize: "11px",
                        color: "rgba(0,0,0,0.4)",
                        margin: "0px",
                      }}
                    >
                      Loan Accepted
                    </h3>
                    <>
                      {activeUser2.loanAccepted.map((loan, index) => {
                        const isLate = hasLateDays(loan, 0);
                        const todayDateString = getCurrentDate();
                        const isAlmostThreeDay = hasAlmostThreeDay(
                          loan,
                          todayDateString
                        );

                        return (
                          <div
                            key={index}
                            style={{
                              background: "rgba(255,255,255,0.7)",
                              boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
                              borderRadius: "10px",
                              width: "100%",
                              marginTop: "10px",
                              display: "flex",
                              justifyContent: "space-between",
                              padding: "10px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setSelectedLoan(loan);
                              setModal2(true);
                            }}
                          >
                            <div>
                              <p
                                style={{
                                  fontFamily: "Manrope, sans-serif",
                                  fontWeight: "800",
                                  fontSize: "12px",
                                  textAlign: "left",
                                  color: "rgba(0,0,0,0.5)",
                                  margin: "0px",
                                }}
                              >
                                {loan.loan_id}
                              </p>
                              <p
                                style={{
                                  fontFamily: "Manrope, sans-serif",
                                  fontWeight: "800",
                                  fontSize: "18px",
                                  textAlign: "left",
                                  color: "rgba(20, 44, 68, 0.8)",
                                  margin: "0px",
                                }}
                              >
                                {loan.amount}
                              </p>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                flexDirection: "column",
                                alignItems: "flex-end",
                              }}
                            >
                              {/* <div
      style={{
        height: "8px",
        width: "8px",
        borderRadius: "8px",
        background:
          loan.status === "accepted" ? "green" : "yellow",
        boxShadow:
          loan.status === "accepted"
            ? "0px 0px 5px green"
            : "0px 0px 5px yellow",
      }}
    ></div> */}
                              <div
                                className={isLate ? "blink" : ""}
                                style={{
                                  height: "8px",
                                  width: "8px",
                                  borderRadius: "8px",
                                  background: isAlmostThreeDay
                                    ? "red"
                                    : loan.status === "accepted"
                                    ? "green"
                                    : "yellow",
                                  boxShadow:
                                    loan.status === "accepted"
                                      ? "0px 0px 5px green"
                                      : "0px 0px 5px yellow",
                                }}
                              ></div>

                              <p
                                style={{
                                  fontFamily: "Manrope, sans-serif",
                                  fontWeight: "800",
                                  fontSize: "12px",
                                  textAlign: "left",
                                  color: "rgba(0,0,0,0.5)",
                                  margin: "0px",
                                }}
                              >
                                {new Date(loan.created_at).toLocaleDateString(
                                  "en-US",
                                  options
                                )}
                              </p>
                            </div>
                          </div>
                        );
                      })}
                    </>
                  </div>
                  <div
                    style={{
                      flex: 1,
                      textAlign: "left",
                      marginLeft: "0px",
                      width: "100%",
                    }}
                  >
                    <h3
                      style={{
                        fontFamily: "Manrope, sans-serif",
                        fontWeight: "600",
                        fontSize: "11px",
                        color: "rgba(0,0,0,0.4)",
                        margin: "0px",
                      }}
                    >
                      Loan Offered
                    </h3>
                    {activeUser.loanOffers
                      ? activeUser.loanOffers.map((loan, index) => (
                          <div
                            key={index}
                            style={{
                              background: "rgba(255,255,255,0.7)",
                              boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
                              borderRadius: "10px",
                              width: "100%",
                              marginTop: "10px",
                              display: "flex",
                              justifyContent: "space-between",
                              padding: "10px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setSelectedLoan2(loan);
                              setModal3(true);
                            }}
                          >
                            <div>
                              <p
                                style={{
                                  fontFamily: "Manrope, sans-serif",
                                  fontWeight: "800",
                                  fontSize: "12px",
                                  textAlign: "left",
                                  color: "rgba(0,0,0,0.5)",
                                  margin: "0px",
                                }}
                              >
                                {loan.loan_id}
                              </p>
                              <p
                                style={{
                                  fontFamily: "Manrope, sans-serif",
                                  fontWeight: "800",
                                  fontSize: "18px",
                                  textAlign: "left",
                                  color: "rgba(20, 44, 68, 0.8)",
                                  margin: "0px",
                                }}
                              >
                                {loan.offer_amount}
                              </p>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                flexDirection: "column",
                                alignItems: "flex-end",
                              }}
                            >
                              <div
                                style={{
                                  height: "8px",
                                  width: "8px",
                                  borderRadius: "8px",
                                  background:
                                    loan.status === "ongoing"
                                      ? "green"
                                      : "yellow",
                                  boxShadow:
                                    loan.status === "ongoing"
                                      ? "0px 0px 5px green"
                                      : "0px 0px 5px yellow",
                                }}
                              ></div>
                              <p
                                style={{
                                  fontFamily: "Manrope, sans-serif",
                                  fontWeight: "800",
                                  fontSize: "12px",
                                  textAlign: "left",
                                  color: "rgba(0,0,0,0.5)",
                                  margin: "0px",
                                }}
                              >
                                {new Date(loan.created_at).toLocaleDateString(
                                  "en-US",
                                  options
                                )}
                              </p>
                            </div>
                          </div>
                        ))
                      : null}
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    background: "rgba(255,255,255,0.7)",
                    height: "78vh",
                    width: "100%",
                    borderRadius: "10px",
                    marginTop: "15px",
                    color: "#142C44CC",
                    fontFamily: "Manrope, sans-serif",
                    fontWeight: "800",
                    fontSize: "11px",
                    padding: "10px",
                  }}
                >
                  No user selected
                </div>
              )}
            </div>
          ) : (
            <div
              style={{
                background: "rgba(255,255,255,0.7)",
                height: "78vh",
                width: "100%",
                borderRadius: "10px",
                marginTop: "15px",
                color: "#142C44CC",
                fontFamily: "Manrope, sans-serif",
                fontWeight: "800",
                fontSize: "11px",
                padding: "10px",
              }}
            >
              No user selected
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserDatabase;
